// @ts-nocheck
/* Options:
Date: 2026-10-01 17:07:50
Version: 10.14
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:44377

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: immerable:immer
*/

import { immerable } from "immer";
// @ts-nocheck

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IDelete
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export enum ConsentWorkflow
{
    Standard = 1,
    EConsent = 2,
}

export interface IConsentFormConfigurationRequest
{
    patientId?: number;
    formDefinitionId?: number;
    workflow?: ConsentWorkflow;
    participantFirstName?: string;
    participantLastName?: string;
    participantEmailAddress?: string;
    assignedInvestigatorUsername?: string;
    assignedInvestigatorSpecify?: string;
    picfId?: number;
    picfVersion?: string;
}

export enum PatientStateType
{
    Screening = 1,
    Consent = 2,
    OnStudy = 3,
    ScreeningFailed = 4,
}

export enum EventDefinitionType
{
    Screening = 1,
    Consent = 2,
    Staff = 3,
    Status = 4,
}

export enum FormDefinitionType
{
    ScreeningForm = 1,
    ScreenFailForm = 2,
    MainConsentForm = 3,
    OptionalConsentForm = 4,
    ServicesAustraliaConsentForm = 5,
    RandomisationForm = 6,
    PathologyTrackingForm = 7,
    PathologyTrackingEventForm = 8,
    CommentsAndIssuesForm = 9,
    CommentsAndIssuesEventForm = 10,
    SourceDocumentForm = 11,
    StatusForm = 12,
    StatusEventForm = 13,
    TransferForm = 14,
    TransferEventForm = 15,
}

export enum LookupYesNoType
{
    No = 0,
    Yes = 1,
}

// @DataContract
export class FileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public extension: string;

    // @DataMember(Order=4)
    public fileSize?: number;

    // @DataMember(Order=5)
    public contentType: string;

    // @DataMember(Order=6)
    public image: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class File
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public propertyName: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    // @Ignore()
    public upload: FileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export interface IEConsentRequest
{
    guid: string;
}

// @DataContract
export class MainConsentFormEConsentPatientForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientSignedConsent?: number;

    // @DataMember(Order=2)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=3)
    public participantAgreedToProvideBloodSample?: number;

    // @DataMember(Order=4)
    public participantAgreedToCompleteQuestionnaires?: number;

    public constructor(init?: Partial<MainConsentFormEConsentPatientForm>) { (Object as any).assign(this, init); }
}

export enum ConsentStatus
{
    InProgress = 1,
    AwaitingParticipantSignature = 2,
    AwaitingInvestigatorSignature = 3,
    Completed = 4,
}

export enum FormStatusType
{
    DataEntry = 1,
    Locked = 2,
}

// @DataContract
export class MainConsentForm implements IEConsentForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public consentStatus?: ConsentStatus;

    // @DataMember(Order=12)
    public picfId?: number;

    // @DataMember(Order=13)
    public picfVersion?: string;

    // @DataMember(Order=14)
    public picfVersionSpecify?: string;

    // @DataMember(Order=15)
    public patientSignedConsent?: number;

    // @DataMember(Order=16)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=17)
    public investigatorSignedConsent?: number;

    // @DataMember(Order=18)
    public dateInvestigatorSignedConsent?: string;

    // @DataMember(Order=19)
    public workflow?: ConsentWorkflow;

    // @DataMember(Order=20)
    public participantFirstName?: string;

    // @DataMember(Order=21)
    public participantLastName?: string;

    // @DataMember(Order=22)
    public participantEmailAddress?: string;

    // @DataMember(Order=23)
    public assignedInvestigatorUsername?: string;

    // @DataMember(Order=24)
    public assignedInvestigatorSpecify?: string;

    // @DataMember(Order=25)
    public participantAccessGuid?: string;

    // @DataMember(Order=26)
    public participantAgreedToProvideBloodSample?: number;

    // @DataMember(Order=27)
    public participantAgreedToCompleteQuestionnaires?: number;

    // @DataMember(Order=28)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<MainConsentForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentPatientForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientSignedConsent?: number;

    // @DataMember(Order=2)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=3)
    public agreedToTissueSampleStorage?: number;

    // @DataMember(Order=4)
    public agreedToBloodStorage?: number;

    // @DataMember(Order=5)
    public agreedToInfoSharing?: number;

    // @DataMember(Order=6)
    public agreedToWeShareSharing?: number;

    public constructor(init?: Partial<OptionalConsentFormEConsentPatientForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentForm implements IEConsentForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public consentStatus?: ConsentStatus;

    // @DataMember(Order=12)
    public picfId?: number;

    // @DataMember(Order=13)
    public picfVersion?: string;

    // @DataMember(Order=14)
    public picfVersionSpecify?: string;

    // @DataMember(Order=15)
    public patientSignedConsent?: number;

    // @DataMember(Order=16)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=17)
    public investigatorSignedConsent?: number;

    // @DataMember(Order=18)
    public dateInvestigatorSignedConsent?: string;

    // @DataMember(Order=19)
    public workflow?: ConsentWorkflow;

    // @DataMember(Order=20)
    public participantFirstName?: string;

    // @DataMember(Order=21)
    public participantLastName?: string;

    // @DataMember(Order=22)
    public participantEmailAddress?: string;

    // @DataMember(Order=23)
    public assignedInvestigatorUsername?: string;

    // @DataMember(Order=24)
    public assignedInvestigatorSpecify?: string;

    // @DataMember(Order=25)
    public participantAccessGuid?: string;

    // @DataMember(Order=26)
    public agreedToTissueSampleStorage?: number;

    // @DataMember(Order=27)
    public agreedToBloodStorage?: number;

    // @DataMember(Order=28)
    public agreedToInfoSharing?: number;

    // @DataMember(Order=29)
    public agreedToWeShareSharing?: number;

    // @DataMember(Order=30)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<OptionalConsentForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentPatientForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientSignedConsent?: number;

    // @DataMember(Order=2)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=3)
    public participantAgreedToDisclosureOfInformation?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentPatientForm>) { (Object as any).assign(this, init); }
}

export enum SourceDocumentType
{
    Histopathology = 1,
    Imaging = 2,
    Consent = 3,
}

// @DataContract
export class SourceDocumentForm implements IForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public type?: SourceDocumentType;

    // @DataMember(Order=12)
    public name?: string;

    // @DataMember(Order=13)
    public file?: File;

    public constructor(init?: Partial<SourceDocumentForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentForm implements IEConsentForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public consentStatus?: ConsentStatus;

    // @DataMember(Order=12)
    public picfId?: number;

    // @DataMember(Order=13)
    public picfVersion?: string;

    // @DataMember(Order=14)
    public picfVersionSpecify?: string;

    // @DataMember(Order=15)
    public patientSignedConsent?: number;

    // @DataMember(Order=16)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=17)
    public investigatorSignedConsent?: number;

    // @DataMember(Order=18)
    public dateInvestigatorSignedConsent?: string;

    // @DataMember(Order=19)
    public workflow?: ConsentWorkflow;

    // @DataMember(Order=20)
    public participantFirstName?: string;

    // @DataMember(Order=21)
    public participantLastName?: string;

    // @DataMember(Order=22)
    public participantEmailAddress?: string;

    // @DataMember(Order=23)
    public assignedInvestigatorUsername?: string;

    // @DataMember(Order=24)
    public assignedInvestigatorSpecify?: string;

    // @DataMember(Order=25)
    public participantAccessGuid?: string;

    // @DataMember(Order=26)
    public participantAgreedToDisclosureOfInformation?: number;

    // @DataMember(Order=27)
    public sourceDocuments: SourceDocumentForm[];

    // @DataMember(Order=28)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<ServicesAustraliaConsentForm>) { (Object as any).assign(this, init); }
}

export interface IConsentPendingGetSingleById extends IGet
{
    id?: number;
}

export interface IConsentPendingGetCollection extends IGet
{
}

export interface IConsentPendingGetCollectionByInstitutionCode extends IGet
{
    institutionCode?: string;
}

export enum StatusTypeEnum
{
    Waiting = 1,
    Responded = 2,
    NotInterested = 3,
    PatientSigning = 4,
    InvestigatorSigning = 5,
    VerifyingDocument = 6,
    Completed = 7,
    Refused = 8,
}

// @DataContract
export class ConsentPending implements IConsentPending
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public patientId?: number;

    // @DataMember(Order=3)
    public institutionCode: string;

    // @DataMember(Order=4)
    public emailAddress: string;

    // @DataMember(Order=5)
    public dateSent?: string;

    // @DataMember(Order=6)
    public investigator: string;

    // @DataMember(Order=7)
    public firstName: string;

    // @DataMember(Order=8)
    public lastName: string;

    // @DataMember(Order=9)
    public confirmed?: boolean;

    // @DataMember(Order=10)
    public dateSubmitted?: string;

    // @DataMember(Order=11)
    public statusId?: StatusTypeEnum;

    // @DataMember(Order=12)
    public enteredDate?: string;

    // @DataMember(Order=13)
    public enteredBy: string;

    public constructor(init?: Partial<ConsentPending>) { (Object as any).assign(this, init); }
}

export interface IConsentPendingDelete extends IDelete
{
    id?: number;
}

export interface IPatientConsentGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientConsentGetSingleByGuid extends IGet
{
    guid?: string;
}

export interface IPatientConsentGetCollection extends IGet
{
}

export interface IPatientConsentGetCollectionByInstitutionCode extends IGet
{
    institutionCode?: string;
}

export enum ConsentTypeEnum
{
    Remote = 1,
    FaceToFace = 2,
    Standard = 3,
}

export class ConsentPicf
{
    [immerable]? = true;

    public id?: number;
    public consentId?: number;
    public picfTypeId?: number;
    public picfId?: number;
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<ConsentPicf>) { (Object as any).assign(this, init); }
}

export class ConsentFileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    public guid?: string;
    public name?: string;
    public extension?: string;
    public fileSize?: number;
    public contentType?: string;
    public image: boolean;

    public constructor(init?: Partial<ConsentFileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class ConsentFileUpload
{
    [immerable]? = true;

    public extension?: string;
    public fileSize?: number;
    public contentType?: string;
    public exists: boolean;
    public image: boolean;
    public upload?: ConsentFileUploadTemporary;

    public constructor(init?: Partial<ConsentFileUpload>) { (Object as any).assign(this, init); }
}

export class ConsentType
{
    [immerable]? = true;

    public id: ConsentTypeEnum;
    public value?: string;

    public constructor(init?: Partial<ConsentType>) { (Object as any).assign(this, init); }
}

export class StatusType
{
    [immerable]? = true;

    public id: StatusTypeEnum;
    public value?: string;

    public constructor(init?: Partial<StatusType>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Eoi
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public invitationId?: number;

    // @DataMember(Order=3)
    public firstName: string;

    // @DataMember(Order=4)
    public lastName: string;

    // @DataMember(Order=5)
    public confirmed?: boolean;

    // @DataMember(Order=6)
    public dateSubmitted?: string;

    // @DataMember(Order=7)
    public statusId?: StatusTypeEnum;

    // @DataMember(Order=8)
    public enteredDate?: string;

    // @DataMember(Order=9)
    public enteredBy: string;

    // @DataMember(Order=10)
    public modifiedDate?: string;

    // @DataMember(Order=11)
    public modifiedBy: string;

    public constructor(init?: Partial<Eoi>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsent
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    // @References("typeof(OptPembro.ServiceLogic.Models.Dos.EConsent.ConsentPending)")
    public consentPendingId?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.EConsent.Models.Dos.ConsentType)")
    public typeId?: ConsentTypeEnum;

    // @DataMember(Order=5)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.EConsent.Models.Dos.StatusType)")
    public statusId?: StatusTypeEnum;

    // @DataMember(Order=6)
    public guid: string;

    // @DataMember(Order=7)
    public dateStarted?: string;

    // @DataMember(Order=8)
    public mobileNumber: string;

    // @DataMember(Order=9)
    public patientSigned?: boolean;

    // @DataMember(Order=10)
    public datePatientSigned?: string;

    // @DataMember(Order=11)
    public investigatorSigned?: boolean;

    // @DataMember(Order=12)
    public dateInvestigatorSigned?: string;

    // @DataMember(Order=13)
    public documentVerified?: boolean;

    // @DataMember(Order=14)
    public documentVerifiedBy: string;

    // @DataMember(Order=15)
    public dateDocumentVerified?: string;

    // @DataMember(Order=16)
    public dateNotificationSent?: string;

    // @DataMember(Order=17)
    public storageOfTissueSamples?: boolean;

    // @DataMember(Order=18)
    // @Ignore()
    public picfs: ConsentPicf[];

    // @DataMember(Order=19)
    // @Ignore()
    public documentUpload: ConsentFileUpload;

    // @DataMember(Order=20)
    public type: ConsentType;

    // @DataMember(Order=21)
    public status: StatusType;

    // @DataMember(Order=22)
    public eoi: Eoi;

    // @DataMember(Order=23)
    public enteredDate?: string;

    // @DataMember(Order=24)
    public enteredBy: string;

    // @DataMember(Order=25)
    public modifiedDate?: string;

    // @DataMember(Order=26)
    public modifiedBy: string;

    public constructor(init?: Partial<PatientConsent>) { (Object as any).assign(this, init); }
}

export interface IPatientConsentDelete extends IDelete
{
    id?: number;
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IEventDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IEventDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IEventDefinitionGetCollection extends IGet
{
}

export interface IFormDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IFormDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IFormDefinitionGetCollection extends IGet
{
}

export interface IPatientStateGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientStateGetCollection extends IGet
{
}

export interface ITreatmentGetSingleById extends IGet
{
    id?: number;
}

export interface ITreatmentGetCollection extends IGet
{
}

export interface IMasterGroupGetSingleById extends IGet
{
    id?: number;
}

export interface IMasterGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface IMasterGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetSingleById extends IGet
{
    id?: number;
}

export interface ICollaboratingGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface ICollaboratingGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICollaboratingGroupGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetSingleById extends IGet
{
    id?: number;
}

export interface ICountryGetSingleByCode extends IGet
{
    code: string;
}

export interface ICountryGetCollection extends IGet
{
}

export interface ICountryGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICountryGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
}

export interface ICountryGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
}

export interface IInstitutionGetSingleById extends IGet
{
    id?: number;
}

export interface IInstitutionGetSingleByCode extends IGet
{
    code: string;
}

export interface IInstitutionGetCollection extends IGet
{
}

export interface IInstitutionGetCollectionByCountryId extends IGet
{
    countryId?: number;
}

export interface IInstitutionGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCountryCode extends IGet
{
    countryCode: string;
}

export interface IInstitutionGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
}

export interface IInstitutionGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
}

export interface IPatientGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientGetSingleByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetValidationById extends IGet
{
    id?: number;
    patientOnly?: boolean;
}

export interface IPatientGetValidationByStudyNumber extends IGet
{
    studyNumber: string;
    patientOnly?: boolean;
}

export interface IPatientGetCollection extends IGet
{
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryId extends IGet
{
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionId extends IGet
{
    institutionId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryCode extends IGet
{
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
    patientStateIds: number[];
}

export enum PatientStatusEventType
{
    OnStudy = 1,
    WcFull = 2,
    WcBlood = 3,
    WcQuestionnaires = 4,
    WcServAus = 5,
    WcDataLink = 6,
    WcTissue = 7,
    WcBloodSampleStorage = 8,
    WcDataSharing = 9,
    WcWeShareData = 10,
    LostToFollowUp = 11,
    Deceased = 12,
}

// @DataContract
export class StatusEventForm implements IForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public statusEvent?: PatientStatusEventType;

    // @DataMember(Order=12)
    public dateEffective?: string;

    // @DataMember(Order=13)
    public comments?: string;

    public constructor(init?: Partial<StatusEventForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class Patient implements IPatient, IRegistrationPatient
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public studyNumber: string;

    // @DataMember(Order=3)
    public temporaryNumber: string;

    // @DataMember(Order=4)
    public registrationNumber: string;

    // @DataMember(Order=5)
    public treatmentId?: number;

    // @DataMember(Order=6)
    public enrollingInstitutionId?: number;

    // @DataMember(Order=7)
    public enrollingInstitutionCode?: string;

    // @DataMember(Order=8)
    public institutionId?: number;

    // @DataMember(Order=9)
    public institutionCode?: string;

    // @DataMember(Order=10)
    public patientStateId?: number;

    // @DataMember(Order=11)
    public previousPatientStateId?: number;

    // @DataMember(Order=12)
    public patientStateChangeDate?: string;

    // @DataMember(Order=13)
    public initials?: string;

    // @DataMember(Order=14)
    public screeningDate?: string;

    // @DataMember(Order=15)
    public consentDate?: string;

    // @DataMember(Order=16)
    public registrationDate?: string;

    // @DataMember(Order=17)
    public enteredDate?: string;

    // @DataMember(Order=18)
    public enteredBy: string;

    // @DataMember(Order=19)
    public modifiedDate?: string;

    // @DataMember(Order=20)
    public modifiedBy: string;

    // @DataMember(Order=21)
    // @Ignore()
    public ineligibleReason?: string;

    // @DataMember(Order=22)
    public email?: string;

    // @DataMember(Order=23)
    public firstName?: string;

    // @DataMember(Order=24)
    public lastName?: string;

    // @DataMember(Order=25)
    // @Ignore()
    public statusEvents: StatusEventForm[];

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export interface IEventGetValidationByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    eventOnly?: boolean;
}

export interface IEventGetSingleById extends IGet
{
    id?: number;
}

export interface IEventGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetCollection extends IGet
{
}

export interface IEventGetCollectionByPatientId extends IGet
{
    patientId?: number;
}

export interface IEventGetCollectionByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
}

// @DataContract
export class Event implements IEvent
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public patientId?: number;

    // @DataMember(Order=3)
    public eventDefinitionId?: number;

    // @DataMember(Order=4)
    public repeat?: number;

    // @DataMember(Order=5)
    public enteredDate?: string;

    // @DataMember(Order=6)
    public enteredBy: string;

    // @DataMember(Order=7)
    public modifiedDate?: string;

    // @DataMember(Order=8)
    public modifiedBy: string;

    public constructor(init?: Partial<Event>) { (Object as any).assign(this, init); }
}

export interface IFormGetSingleById extends IGet
{
    id?: number;
}

export interface IFormGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetCollection extends IGet
{
}

export interface IFormGetCollectionByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export interface IFormGetCollectionByCodes extends IGet
{
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
}

// @DataContract
export class CommentsAndIssuesEventForm implements IForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public date?: string;

    // @DataMember(Order=12)
    public user?: string;

    // @DataMember(Order=13)
    public comments?: string;

    public constructor(init?: Partial<CommentsAndIssuesEventForm>) { (Object as any).assign(this, init); }
}

export interface IFormPostUpdateStatusByIds
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    formStatus?: FormStatusType;
}

// @DataContract
export class CommentsAndIssuesForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public commentsAndIssuesEvents?: CommentsAndIssuesEventForm[];

    // @DataMember(Order=12)
    public sourceDocuments?: SourceDocumentForm[];

    // @DataMember(Order=13)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<CommentsAndIssuesForm>) { (Object as any).assign(this, init); }
}

export enum TimePointType
{
    Randomisation = 1,
    OnStudySixMonths = 2,
    EndOfTreatment = 3,
    ThreeMonthFollowUp = 4,
    SixMonthFollowUp = 5,
    NineMonthFollowUp = 6,
    TwelveMonthFollowUp = 7,
    EighteenMonthFollowUp = 8,
    TwentyFourMonthFollowUp = 9,
    ThirtyMonthFollowUp = 10,
    ThirtySixMonthFollowUp = 11,
    FourtyTwoMonthFollowUp = 12,
    FourtyEightMonthFollowUp = 13,
    SixtyMonthFollowUp = 14,
    SeventyTwoFollowUp = 15,
    EightyFourFollowUp = 16,
    NinetySixFollowUp = 17,
    OneHundredEightFollowUp = 18,
    OneHundredTwentyFollowUp = 19,
    Baseline = 20,
    TwelveWeeks = 21,
    Recurrence = 22,
    Other = 0,
}

export enum SampleType
{
    SampleType1 = 1,
    SampleType2 = 2,
}

// @DataContract
export class PathologyTrackingEventForm implements IForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public timePoint?: TimePointType;

    // @DataMember(Order=12)
    public sampleType?: string;

    // @DataMember(Order=13)
    public date?: string;

    // @DataMember(Order=14)
    public notDone?: boolean;

    // @DataMember(Order=15)
    public comments?: string;

    // @DataMember(Order=16)
    public doNotPay?: boolean;

    // @DataMember(Order=17)
    public specimenId?: number;

    // @DataMember(Order=18)
    public timePointSpecify?: string;

    public constructor(init?: Partial<PathologyTrackingEventForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public pathologyTrackingEvents?: PathologyTrackingEventForm[];

    // @DataMember(Order=12)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<PathologyTrackingForm>) { (Object as any).assign(this, init); }
}

export enum RandomisationArmType
{
    ArmA = 1,
    ArmB = 2,
}

// @DataContract
export class RandomisationForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public randomisationArm?: RandomisationArmType;

    // @DataMember(Order=12)
    public randNo?: string;

    // @DataMember(Order=13)
    public postCode?: string;

    // @DataMember(Order=14)
    public mainLanguageChild?: number;

    // @DataMember(Order=17)
    public mainLanguageChildOther?: boolean;

    // @DataMember(Order=18)
    public mainLanguageChildOtherSpecify?: string;

    // @DataMember(Order=19)
    public mainLanguage?: number;

    // @DataMember(Order=20)
    public mainLanguageOther?: boolean;

    // @DataMember(Order=30)
    public mainLanguageOtherSpecify?: string;

    // @DataMember(Order=31)
    public birthCountry?: number;

    // @DataMember(Order=32)
    public birthCountryOther?: boolean;

    // @DataMember(Order=33)
    public birthCountryOtherSpecify?: string;

    // @DataMember(Order=34)
    public ethnicity?: number;

    // @DataMember(Order=35)
    public ethnicityUnkown?: boolean;

    // @DataMember(Order=36)
    public indigenous?: number;

    // @DataMember(Order=37)
    public indigenousAboriginal?: boolean;

    // @DataMember(Order=38)
    public indigenousSouthSeaIslander?: boolean;

    // @DataMember(Order=39)
    public indigenousTorresStraitIslander?: boolean;

    // @DataMember(Order=40)
    public indigenousNorfolkIslander?: boolean;

    // @DataMember(Order=41)
    public indigenousMaori?: boolean;

    // @DataMember(Order=42)
    public indigenousPacificPeoples?: boolean;

    // @DataMember(Order=43)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<RandomisationForm>) { (Object as any).assign(this, init); }
}

export enum LookupScreeningOutcomeType
{
    Proceed = 1,
    Fail = 2,
}

export enum LookupScreenFailReasonType
{
    ParticipantIneligible = 1,
    ClinicianDeemedUnsuitable = 2,
    ParticipantPrefersStandardCare = 3,
    ParticipantDeclinedNoReason = 4,
}

// @DataContract
export class ScreeningForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public initials?: string;

    // @DataMember(Order=12)
    public dob?: string;

    // @DataMember(Order=13)
    public outcome?: LookupScreeningOutcomeType;

    // @DataMember(Order=14)
    public screenFailReason?: LookupScreenFailReasonType;

    // @DataMember(Order=15)
    public email?: string;

    // @DataMember(Order=16)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<ScreeningForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public statusEvents?: StatusEventForm[];

    // @DataMember(Order=12)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<StatusForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventForm implements IForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public dateBctAdvised?: string;

    // @DataMember(Order=12)
    public institutionId?: number;

    // @DataMember(Order=13)
    public referralLetterDate?: string;

    // @DataMember(Order=14)
    public consentSignedDate?: string;

    // @DataMember(Order=15)
    public transferConfirmedDate?: string;

    // @DataMember(Order=16)
    public firstFollowUpDate?: string;

    public constructor(init?: Partial<TransferEventForm>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferForm implements IForm, IHasFormStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public enteredDate?: string;

    // @DataMember(Order=4)
    public enteredBy: string;

    // @DataMember(Order=5)
    public modifiedDate?: string;

    // @DataMember(Order=6)
    public modifiedBy: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public eventId?: number;

    // @DataMember(Order=9)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=10)
    public parentFormId?: number;

    // @DataMember(Order=11)
    public transfers?: TransferEventForm[];

    // @DataMember(Order=12)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<TransferForm>) { (Object as any).assign(this, init); }
}

export interface IQueryGetSingleById extends IGet
{
    id?: number;
}

export interface IQueryGetCollection extends IGet
{
}

export interface IQueryGetCollectionByForm extends IGet
{
    patientId?: number;
    formDefinitionId?: number;
    formId?: number;
}

export interface IQueryGetCollectionByFormProperty extends IGet
{
    patientId?: number;
    formDefinitionId?: number;
    formId?: number;
    propertyPath?: string;
}

export enum QueryType
{
    Query = 1,
    ProtocolDeviation = 2,
}

export enum QueryStatusType
{
    Open = 1,
    ResolutionProposed = 2,
    Closed = 3,
}

export enum QueryActionType
{
    Open = 1,
    ProposeResolution = 2,
    RejectResolution = 3,
    Close = 4,
    AddInformation = 5,
}

export class Subquery implements ISubquery
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Data.Query)")
    public queryId?: number;

    public action?: QueryActionType;
    public comments?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Subquery>) { (Object as any).assign(this, init); }
}

export class Query implements IQuery
{
    [immerable]? = true;

    public id?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public queryType?: QueryType;
    public queryStatus?: QueryStatusType;
    public title?: string;
    public propertyPath?: string;
    public subqueries?: Subquery[];
    public enteredDate?: string;
    public enteredBy?: string;
    public modifiedDate?: string;
    public modifiedBy?: string;

    public constructor(init?: Partial<Query>) { (Object as any).assign(this, init); }
}

export interface IQueryDeleteById extends IDelete
{
    queryId?: number;
}

export interface ISubqueryGetCollectionByQueryId extends IGet
{
    queryId?: number;
}

export interface IPatientGetEventStatesById extends IGet
{
    id?: number;
}

export interface IPatientGetEventStatesByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetFormStatesByIds extends IGet
{
    id?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
    PISignOffView = 43,
    PISignOffPerform = 44,
    PISignOffAdminister = 45,
    OpmsDataManage = 46,
    RedactVerificationAccess = 47,
    ReconsentAdminister = 48,
    TrialManagementAccess = 49,
    SourceDataVerificationAccess = 50,
    TrialParticipantAccess = 51,
    StaffTrainingAccess = 52,
    TrainingAccess = 53,
    ReportAccess = 54,
    WebsiteImporterAccess = 55,
    ConstituentManagerAccess = 56,
    OpmsBypassErrors = 57,
    RadiologyReviewAccess = 58,
    ApproveInvoice = 59,
    PrescreeningAccess = 60,
    PrescreeningAdminister = 61,
    InvoiceExportView = 62,
    InvoiceExportUpdate = 63,
    InvoiceRequisitionView = 64,
    InvoiceRequisitionUpdate = 65,
    CanCentralReview = 66,
    InvoiceView = 67,
    InvoiceUpdate = 68,
    IsSiteUser = 69,
    TissueBankAdmin = 70,
    CanViewQuerySummaries = 71,
}

export enum FormType
{
    Crf = 1,
    Pro = 2,
    Staff = 3,
}

export enum ValidationErrorType
{
    Warning = 1,
    Ineligible = 2,
    Normal = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName: string;
    public label: string;
    public detailedLabel: string;
    public errorMessages: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable]? = true;

    public id?: number;
    public testProperty?: number;
    public code: string;
    public type?: FormType;
    public name: string;
    public instructions?: string;
    public patientInstructions?: string;
    public properties: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties: { [index:string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinitionState implements IEventDefinitionFormDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinitionFormDefinition)")
    public eventDefinitionFormDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;

    public constructor(init?: Partial<EventDefinitionFormDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinition
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public states: EventDefinitionFormDefinitionState[];

    public constructor(init?: Partial<EventDefinitionFormDefinition>) { (Object as any).assign(this, init); }
}

export class EventDefinitionState implements IEventDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manageForms?: boolean;

    public constructor(init?: Partial<EventDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionErrorMessage implements IEventDefinitionErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventDefinitionErrorMessage>) { (Object as any).assign(this, init); }
}

export class EventDefinition
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public code: string;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public formDefinitions: EventDefinitionFormDefinition[];
    public states: EventDefinitionState[];
    public errorMessages: EventDefinitionErrorMessage[];

    public constructor(init?: Partial<EventDefinition>) { (Object as any).assign(this, init); }
}

export class PatientState implements IPatientState
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public order?: number;

    public constructor(init?: Partial<PatientState>) { (Object as any).assign(this, init); }
}

export class Treatment implements ITreatment
{
    [immerable]? = true;

    public id?: number;
    public name: string;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}

export class PicfType
{
    [immerable]? = true;

    public id?: number;
    public name?: string;
    public label?: string;
    public fileName?: string;

    public constructor(init?: Partial<PicfType>) { (Object as any).assign(this, init); }
}

export class Picf
{
    [immerable]? = true;

    public type?: PicfType;
    public picfId?: number;
    public name?: string;
    public label?: string;
    public version?: string;
    public fileName?: string;
    public file?: string;

    public constructor(init?: Partial<Picf>) { (Object as any).assign(this, init); }
}

export class EmailAddress
{
    [immerable]? = true;

    public displayName: string;
    public address: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export interface IEmailResult
{
    result?: string;
    subject?: string;
    toAddresses?: EmailAddress[];
    ccAddresses?: EmailAddress[];
    bccAddresses?: EmailAddress[];
    fromAddress?: EmailAddress;
}

// @DataContract
export class EConsentPatientDisplayContext
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public formDefinitionCode?: string;

    // @DataMember(Order=2)
    public formDefinitionName?: string;

    // @DataMember(Order=3)
    public participantName?: string;

    // @DataMember(Order=4)
    public institutionCode?: string;

    // @DataMember(Order=5)
    public institutionName?: string;

    // @DataMember(Order=6)
    public principalInvestigator?: string;

    // @DataMember(Order=7)
    public picfDownloadUrl?: string;

    // @DataMember(Order=8)
    public picfVersion?: string;

    // @DataMember(Order=9)
    public readOnly: boolean;

    // @DataMember(Order=10)
    public consentStatus?: ConsentStatus;

    public constructor(init?: Partial<EConsentPatientDisplayContext>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Ineligible = 2,
    Error = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class FormValidationError implements IFormValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public totalQueries?: number;
    public queryStatuses?: { [index:string]: number; };
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public formId?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public formStatus?: FormStatusType;
    public completed?: boolean;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;
    public errors: FormValidationError[];

    public constructor(init?: Partial<FormValidationResult>) { (Object as any).assign(this, init); }
}

export interface IInstitution extends IDataModel, IHasMasterGroupId, IHasCollaboratingGroupId, IHasCountryId
{
    name: string;
    code: string;
    enabled?: boolean;
    activatedDate?: string;
    recruitmentDisabled?: boolean;
    eConsentActivationDate?: string;
}

// @DataContract
export class ResponseError
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UserApiKey
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public key?: string;

    // @DataMember(Order=2)
    public keyType?: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFormValidationError extends IValidationError
{
    property: string;
}

export interface IFormValidationResult extends IValidationResult
{
    totalQueries?: number;
    queryStatuses?: { [index:string]: number; };
    answeredQuestions?: number;
    totalQuestions?: number;
    formId?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    formStatus?: FormStatusType;
    completed?: boolean;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manage?: boolean;
    errors: IFormValidationError[];
}

export interface IFileUploadTemporary
{
    guid: string;
    name: string;
    extension: string;
    fileSize?: number;
    contentType: string;
    image: boolean;
}

export enum UserType
{
    TrialPersonnel = 1,
    Patient = 2,
}

export class LookupItem implements ILookupItem
{
    [immerable]? = true;

    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable]? = true;

    public propertyName: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class FormMetadata
{
    [immerable]? = true;

    public formDefinitionId?: number;
    public formDefinitionCode: string;
    public name: string;
    public propertyName: string;
    public title: string;
    public instructions: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class MasterGroup implements IMasterGroup
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

export class CollaboratingGroup implements ICollaboratingGroup
{
    [immerable]? = true;

    public id?: number;
    public masterGroupId?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollaboratingGroup>) { (Object as any).assign(this, init); }
}

export class Country implements ICountry
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class Institution implements IInstitution
{
    [immerable]? = true;

    public id?: number;
    public countryId?: number;
    public masterGroupId?: number;
    public collaboratingGroupId?: number;
    public code: string;
    public name: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public recruitmentDisabled?: boolean;
    public eConsentActivationDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export class PatientValidationError implements IPatientValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<PatientValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationError implements IEventValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public eventId?: number;
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public manageForms?: boolean;
    public redactable?: boolean;
    public errors: EventValidationError[];
    public formResults: FormValidationResult[];

    public constructor(init?: Partial<EventValidationResult>) { (Object as any).assign(this, init); }
}

export class PatientValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public patientId?: number;
    public patientDefinitionId?: number;
    public patientRepeat?: number;
    public errors: PatientValidationError[];
    public eventResults: EventValidationResult[];

    public constructor(init?: Partial<PatientValidationResult>) { (Object as any).assign(this, init); }
}

export class QueryValidationError implements IQueryValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<QueryValidationError>) { (Object as any).assign(this, init); }
}

export class QueryValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public queryId?: number;
    public errors: QueryValidationError[];

    public constructor(init?: Partial<QueryValidationResult>) { (Object as any).assign(this, init); }
}

export interface IDeleteResponse
{
}

export class EventState implements IEventState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public manageForms?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventState>) { (Object as any).assign(this, init); }
}

export class FormState implements IFormState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public manage?: boolean;

    public constructor(init?: Partial<FormState>) { (Object as any).assign(this, init); }
}

export class BctUserPermissionContext
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public masterGroupId?: number;

    // @DataMember(Order=2)
    public masterGroupCode?: string;

    // @DataMember(Order=3)
    public collaboratingGroupId?: number;

    // @DataMember(Order=4)
    public collaboratingGroupCode?: string;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public institutionCode?: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public patientStudyNumber?: string;

    // @DataMember(Order=9)
    public permissions?: Permission[];

    public constructor(init?: Partial<BctUserPermissionContext>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnel
{
    [immerable]? = true;

    public id?: number;
    public name?: string;
    public email?: string;

    public constructor(init?: Partial<InstitutionPersonnel>) { (Object as any).assign(this, init); }
}

export interface IFile extends IDataModel, IHasPatientId, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName: string;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IFileUpload
{
    extension: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
    upload: IFileUploadTemporary;
}

export interface IEConsentForm extends IConsentForm
{
    participantAccessGuid?: string;
    workflow?: ConsentWorkflow;
    participantFirstName?: string;
    participantLastName?: string;
    participantEmailAddress?: string;
    assignedInvestigatorUsername?: string;
    assignedInvestigatorSpecify?: string;
}

export interface IConsentForm extends IForm
{
    consentStatus?: ConsentStatus;
    picfId?: number;
    picfVersion?: string;
    picfVersionSpecify?: string;
    patientSignedConsent?: number;
    datePatientSignedConsent?: string;
    investigatorSignedConsent?: number;
    dateInvestigatorSignedConsent?: string;
}

export interface IForm extends IDataModel, IHasPatientId, IHasEventId, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IHasEventId
{
    eventId?: number;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IHasFormStatus
{
    formStatus?: FormStatusType;
}

export interface IConsentPending extends IDataModel
{
    patientId?: number;
    institutionCode?: string;
    emailAddress?: string;
    dateSent?: string;
    investigator?: string;
    firstName?: string;
    lastName?: string;
    confirmed?: boolean;
    dateSubmitted?: string;
    statusId?: StatusTypeEnum;
}

export interface IPatientConsent extends IDataModel
{
    consentPendingId?: number;
    typeId?: ConsentTypeEnum;
    statusId?: StatusTypeEnum;
    patientId?: number;
    guid?: string;
    dateStarted?: string;
    documentVerified?: boolean;
    documentVerifiedBy?: string;
    dateDocumentVerified?: string;
    mobileNumber?: string;
    patientSigned?: boolean;
    datePatientSigned?: string;
    investigatorSigned?: boolean;
    dateInvestigatorSigned?: string;
    dateNotificationSent?: string;
    type?: ConsentType;
    status?: StatusType;
    consentPending?: IConsentPending;
    picfs?: ConsentPicf[];
}

export interface IPatient extends IDataModel, IHasInstitutionId, IHasPatientStateId, IHasTreatmentId
{
    studyNumber: string;
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasPatientStateId
{
    patientStateId?: number;
}

export interface IHasTreatmentId
{
    treatmentId?: number;
}

export interface IRegistrationPatient
{
    registrationNumber: string;
    registrationDate?: string;
}

export interface IEvent extends IDataModel, IHasPatientId, IHasEventDefinitionId
{
    repeat?: number;
}

export interface IHasEventDefinitionId
{
    eventDefinitionId?: number;
}

export interface ISubquery extends IDataModel
{
    queryId?: number;
    action?: QueryActionType;
    comments?: string;
}

export interface IQuery extends IDataModel
{
    formDefinitionId?: number;
    formId?: number;
    queryType?: QueryType;
    queryStatus?: QueryStatusType;
    title: string;
    propertyPath: string;
    subqueries: ISubquery[];
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName: string;
    label: string;
    detailedLabel: string;
    errorMessages: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel
{
    type?: FormType;
    name: string;
    code: string;
    instructions?: string;
    patientInstructions?: string;
    properties: IFormDefinitionProperty[];
    subformProperties: { [index:string]: IFormDefinitionProperty[]; };
}

export interface IConfigurationModel extends IModel
{
}

export interface IEventDefinitionFormDefinitionState extends IConfigurationModel, IHasEventDefinitionFormDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manage?: boolean;
}

export interface IEventDefinitionFormDefinition extends IConfigurationModel, IHasEventDefinitionId, IHasFormDefinitionId
{
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    states: IEventDefinitionFormDefinitionState[];
}

export interface IEventDefinitionState extends IConfigurationModel, IHasEventDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    manageForms?: boolean;
}

export interface IEventDefinitionErrorMessage extends IConfigurationModel, IHasEventDefinitionId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IEventDefinition extends IConfigurationModel
{
    name: string;
    code: string;
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    formDefinitions: IEventDefinitionFormDefinition[];
    states: IEventDefinitionState[];
    errorMessages: IEventDefinitionErrorMessage[];
}

export interface IPatientState extends IConfigurationModel
{
    name: string;
    order?: number;
}

export interface ITreatment extends IConfigurationModel
{
    name: string;
}

export interface IValidationError
{
    message: string;
    detailedMessage: string;
    code: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    result: ValidationResultType;
    errors: IValidationError[];
}

export interface IHasMasterGroupId
{
    masterGroupId?: number;
}

export interface IHasCollaboratingGroupId
{
    collaboratingGroupId?: number;
}

export interface IHasCountryId
{
    countryId?: number;
}

export interface ILookupItem
{
    id?: number;
    value: string;
    order?: number;
    type?: number;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export interface IMasterGroup extends IDataModel
{
    name: string;
    code: string;
}

export interface ICollaboratingGroup extends IDataModel, IHasMasterGroupId
{
    name: string;
    code: string;
}

export interface ICountry extends IDataModel
{
    name: string;
    code: string;
}

export interface IPatientValidationError extends IValidationError
{
}

export interface IEventValidationError extends IValidationError
{
}

export interface IEventValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    eventDefinitionId?: number;
    eventId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manageForms?: boolean;
    redactable?: boolean;
    errors: IEventValidationError[];
    formResults: IFormValidationResult[];
}

export interface IPatientValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    patientId?: number;
    errors: IPatientValidationError[];
    eventResults: IEventValidationResult[];
}

export interface IQueryValidationError extends IValidationError
{
    property: string;
}

export interface IQueryValidationResult extends IValidationResult
{
    queryId?: number;
    errors: IQueryValidationError[];
}

export interface IEventState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manageForms?: boolean;
    redactable?: boolean;
}

export interface IFormState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    manage?: boolean;
    redactable?: boolean;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export interface IHasEventDefinitionFormDefinitionId
{
    eventDefinitionFormDefinitionId?: number;
}

// @DataContract
export class ResponseStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message?: string;

    // @DataMember(Order=3)
    public stackTrace?: string;

    // @DataMember(Order=4)
    public errors?: ResponseError[];

    // @DataMember(Order=5)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class CachedFormDefinitionCollectionResponse
{
    [immerable]? = true;

    public formDefinitions?: FormDefinition[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CachedFormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedEventDefinitionCollectionResponse
{
    [immerable]? = true;

    public eventDefinitions?: EventDefinition[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CachedEventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedPatientStateCollectionResponse
{
    [immerable]? = true;

    public patientStates?: PatientState[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CachedPatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedTreatmentCollectionResponse
{
    [immerable]? = true;

    public treatments?: Treatment[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CachedTreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StartConsentFormResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StartConsentFormResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RestartConsentFormResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RestartConsentFormResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CompleteConsentFormResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CompleteConsentFormResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetConsentVersionsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public consentPicfs?: Picf[];

    public constructor(init?: Partial<GetConsentVersionsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueueConsentInformationEmailResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueConsentInformationEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueueEConsentPatientEmailResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueEConsentPatientEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueueEConsentPatientCompleteEmailResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueEConsentPatientCompleteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendConsentInformationEmailResponse implements IEmailResult
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<SendConsentInformationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentPatientEmailResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<SendEConsentPatientEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentPatientCompleteEmailResponse implements IEmailResult
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<SendEConsentPatientCompleteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentCompleteTrialEmailResponse implements IEmailResult
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<SendEConsentCompleteTrialEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentCompleteEmailResponse implements IEmailResult
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public result?: string;
    public subject?: string;
    public toAddresses?: EmailAddress[];
    public ccAddresses?: EmailAddress[];
    public bccAddresses?: EmailAddress[];
    public fromAddress?: EmailAddress;

    public constructor(init?: Partial<SendEConsentCompleteEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormEConsentFormGetResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public form?: MainConsentFormEConsentPatientForm;

    // @DataMember(Order=3)
    public context?: EConsentPatientDisplayContext;

    public constructor(init?: Partial<MainConsentFormEConsentFormGetResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormEConsentFormValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<MainConsentFormEConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormEConsentFormSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<MainConsentFormEConsentFormSubmitResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormEConsentInvestigatorValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<MainConsentFormEConsentInvestigatorValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormEConsentInvestigatorSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<MainConsentFormEConsentInvestigatorSubmitResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentFormGetResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public form?: OptionalConsentFormEConsentPatientForm;

    // @DataMember(Order=3)
    public context?: EConsentPatientDisplayContext;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormGetResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentFormValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentFormSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormSubmitResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentInvestigatorValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<OptionalConsentFormEConsentInvestigatorValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormEConsentInvestigatorSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<OptionalConsentFormEConsentInvestigatorSubmitResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentFormGetResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentFormEConsentPatientForm;

    // @DataMember(Order=3)
    public context?: EConsentPatientDisplayContext;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormGetResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentFormValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentFormSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormSubmitResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionsResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public institutions?: IInstitution[];

    public constructor(init?: Partial<GetInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class GetInvestigatorsResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public investigators?: { [index:string]: string; };

    public constructor(init?: Partial<GetInvestigatorsResponse>) { (Object as any).assign(this, init); }
}

export class GetPicfsResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public picfs?: Picf[];

    public constructor(init?: Partial<GetPicfsResponse>) { (Object as any).assign(this, init); }
}

export class GetPicfVersionsResponse
{
    [immerable]? = true;

    public picfVersions?: Picf[];
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetPicfVersionsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved consentpending. */
    // @DataMember(Order=2)
    public consentPending?: ConsentPending;

    public constructor(init?: Partial<ConsentPendingSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved consentpendings. */
    // @DataMember(Order=2)
    public consentPendings?: ConsentPending[];

    public constructor(init?: Partial<ConsentPendingCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ConsentPendingDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patientconsent. */
    // @DataMember(Order=2)
    public patientConsent?: PatientConsent;

    public constructor(init?: Partial<PatientConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patientconsents. */
    // @DataMember(Order=2)
    public patientConsents?: PatientConsent[];

    public constructor(init?: Partial<PatientConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PatientConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

export class PatientConsentSendVerificationCodeResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public verificationCode: number;

    public constructor(init?: Partial<PatientConsentSendVerificationCodeResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userId?: string;

    // @DataMember(Order=2)
    public sessionId?: string;

    // @DataMember(Order=3)
    public userName?: string;

    // @DataMember(Order=4)
    public displayName?: string;

    // @DataMember(Order=5)
    public referrerUrl?: string;

    // @DataMember(Order=6)
    public bearerToken?: string;

    // @DataMember(Order=7)
    public refreshToken?: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl?: string;

    // @DataMember(Order=10)
    public roles?: string[];

    // @DataMember(Order=11)
    public permissions?: string[];

    // @DataMember(Order=12)
    public authProvider?: string;

    // @DataMember(Order=13)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=14)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles?: string[];

    // @DataMember(Order=2)
    public allPermissions?: string[];

    // @DataMember(Order=3)
    public meta?: { [index:string]: string; };

    // @DataMember(Order=4)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results?: UserApiKey[];

    // @DataMember(Order=2)
    public meta?: { [index:string]: string; };

    // @DataMember(Order=3)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormValidationByIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public result: IFormValidationResult;

    public constructor(init?: Partial<FormValidationByIdResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public upload: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public type?: UserType;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups?: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public formMetadata: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved event definition. */
    // @DataMember(Order=2)
    public eventDefinition?: EventDefinition;

    public constructor(init?: Partial<EventDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved event definitions. */
    // @DataMember(Order=2)
    public eventDefinitions?: EventDefinition[];

    public constructor(init?: Partial<EventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public formDefinition?: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public formDefinitions?: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patient state. */
    // @DataMember(Order=2)
    public patientState?: PatientState;

    public constructor(init?: Partial<PatientStateSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patient states. */
    // @DataMember(Order=2)
    public patientStates?: PatientState[];

    public constructor(init?: Partial<PatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved treatment. */
    // @DataMember(Order=2)
    public treatment?: Treatment;

    public constructor(init?: Partial<TreatmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved treatments. */
    // @DataMember(Order=2)
    public treatments?: Treatment[];

    public constructor(init?: Partial<TreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved master group. */
    // @DataMember(Order=2)
    public masterGroup?: MasterGroup;

    public constructor(init?: Partial<MasterGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved master groups. */
    // @DataMember(Order=2)
    public masterGroups?: MasterGroup[];

    public constructor(init?: Partial<MasterGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved collaborating group. */
    // @DataMember(Order=2)
    public collaboratingGroup?: CollaboratingGroup;

    public constructor(init?: Partial<CollaboratingGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved collaborating groups. */
    // @DataMember(Order=2)
    public collaboratingGroups?: CollaboratingGroup[];

    public constructor(init?: Partial<CollaboratingGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountrySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved country. */
    // @DataMember(Order=2)
    public country?: Country;

    public constructor(init?: Partial<CountrySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved countrys. */
    // @DataMember(Order=2)
    public countries?: Country[];

    public constructor(init?: Partial<CountryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved institution. */
    // @DataMember(Order=2)
    public institution?: Institution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved institutions. */
    // @DataMember(Order=2)
    public institutions?: Institution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patient. */
    // @DataMember(Order=2)
    public patient?: Patient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: PatientValidationResult;

    public constructor(init?: Partial<PatientValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved patients. */
    // @DataMember(Order=2)
    public patients?: Patient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: EventValidationResult;

    public constructor(init?: Partial<EventValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved event. */
    // @DataMember(Order=2)
    public event?: Event;

    public constructor(init?: Partial<EventSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved events. */
    // @DataMember(Order=2)
    public events?: Event[];

    public constructor(init?: Partial<EventCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesEventFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved comments and issues event form. */
    // @DataMember(Order=2)
    public form?: CommentsAndIssuesEventForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<CommentsAndIssuesEventFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesEventFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved comments and issues event forms. */
    // @DataMember(Order=2)
    public forms?: CommentsAndIssuesEventForm[];

    public constructor(init?: Partial<CommentsAndIssuesEventFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesEventFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CommentsAndIssuesEventFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesEventFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<CommentsAndIssuesEventFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesEventFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CommentsAndIssuesEventFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved comments and issues form. */
    // @DataMember(Order=2)
    public form?: CommentsAndIssuesForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<CommentsAndIssuesFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved comments and issues forms. */
    // @DataMember(Order=2)
    public forms?: CommentsAndIssuesForm[];

    public constructor(init?: Partial<CommentsAndIssuesFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CommentsAndIssuesFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<CommentsAndIssuesFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CommentsAndIssuesFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<CommentsAndIssuesFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved main consent form. */
    // @DataMember(Order=2)
    public form?: MainConsentForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MainConsentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved main consent forms. */
    // @DataMember(Order=2)
    public forms?: MainConsentForm[];

    public constructor(init?: Partial<MainConsentFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<MainConsentFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<MainConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<MainConsentFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved optional consent form. */
    // @DataMember(Order=2)
    public form?: OptionalConsentForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<OptionalConsentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved optional consent forms. */
    // @DataMember(Order=2)
    public forms?: OptionalConsentForm[];

    public constructor(init?: Partial<OptionalConsentFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<OptionalConsentFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<OptionalConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class OptionalConsentFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<OptionalConsentFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingEventFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved pathology tracking event form. */
    // @DataMember(Order=2)
    public form?: PathologyTrackingEventForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<PathologyTrackingEventFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingEventFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved pathology tracking event forms. */
    // @DataMember(Order=2)
    public forms?: PathologyTrackingEventForm[];

    public constructor(init?: Partial<PathologyTrackingEventFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingEventFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PathologyTrackingEventFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingEventFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<PathologyTrackingEventFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingEventFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PathologyTrackingEventFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved pathology tracking form. */
    // @DataMember(Order=2)
    public form?: PathologyTrackingForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<PathologyTrackingFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved pathology tracking forms. */
    // @DataMember(Order=2)
    public forms?: PathologyTrackingForm[];

    public constructor(init?: Partial<PathologyTrackingFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PathologyTrackingFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<PathologyTrackingFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PathologyTrackingFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<PathologyTrackingFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RandomisationFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved randomisation form. */
    // @DataMember(Order=2)
    public form?: RandomisationForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<RandomisationFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RandomisationFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved randomisation forms. */
    // @DataMember(Order=2)
    public forms?: RandomisationForm[];

    public constructor(init?: Partial<RandomisationFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RandomisationFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RandomisationFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RandomisationFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<RandomisationFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RandomisationFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<RandomisationFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved screening form. */
    // @DataMember(Order=2)
    public form?: ScreeningForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ScreeningFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved screening forms. */
    // @DataMember(Order=2)
    public forms?: ScreeningForm[];

    public constructor(init?: Partial<ScreeningFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ScreeningFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<ScreeningFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ScreeningFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved services australia consent form. */
    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved services australia consent forms. */
    // @DataMember(Order=2)
    public forms?: ServicesAustraliaConsentForm[];

    public constructor(init?: Partial<ServicesAustraliaConsentFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ServicesAustraliaConsentFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<ServicesAustraliaConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<ServicesAustraliaConsentFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved source document form. */
    // @DataMember(Order=2)
    public form?: SourceDocumentForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SourceDocumentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved source document forms. */
    // @DataMember(Order=2)
    public forms?: SourceDocumentForm[];

    public constructor(init?: Partial<SourceDocumentFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SourceDocumentFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<SourceDocumentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SourceDocumentFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusEventFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved status event form. */
    // @DataMember(Order=2)
    public form?: StatusEventForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<StatusEventFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusEventFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved status event forms. */
    // @DataMember(Order=2)
    public forms?: StatusEventForm[];

    public constructor(init?: Partial<StatusEventFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusEventFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StatusEventFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusEventFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<StatusEventFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusEventFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StatusEventFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved status form. */
    // @DataMember(Order=2)
    public form?: StatusForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<StatusFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved status forms. */
    // @DataMember(Order=2)
    public forms?: StatusForm[];

    public constructor(init?: Partial<StatusFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StatusFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<StatusFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class StatusFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<StatusFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved transfer event form. */
    // @DataMember(Order=2)
    public form?: TransferEventForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TransferEventFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved transfer event forms. */
    // @DataMember(Order=2)
    public forms?: TransferEventForm[];

    public constructor(init?: Partial<TransferEventFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<TransferEventFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<TransferEventFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferEventFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<TransferEventFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved transfer form. */
    // @DataMember(Order=2)
    public form?: TransferForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TransferFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved transfer forms. */
    // @DataMember(Order=2)
    public forms?: TransferForm[];

    public constructor(init?: Partial<TransferFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<TransferFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: FormValidationResult;

    public constructor(init?: Partial<TransferFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TransferFormUpdateStatusResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<TransferFormUpdateStatusResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QuerySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved query. */
    // @DataMember(Order=2)
    public query?: Query;

    public constructor(init?: Partial<QuerySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved querys. */
    // @DataMember(Order=2)
    public queries?: Query[];

    public constructor(init?: Partial<QueryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult?: QueryValidationResult;

    public constructor(init?: Partial<QueryValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueryDeleteResponse implements IDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueryDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SubqueryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved subquerys. */
    // @DataMember(Order=2)
    public subqueries?: Subquery[];

    public constructor(init?: Partial<SubqueryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SubquerySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved subquery. */
    // @DataMember(Order=2)
    public subquery?: Subquery;

    public constructor(init?: Partial<SubquerySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved event states for the patient. */
    // @DataMember(Order=2)
    public states?: EventState[];

    public constructor(init?: Partial<EventStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    /** @description The retrieved form states for the patient event. */
    // @DataMember(Order=2)
    public states?: FormState[];

    public constructor(init?: Partial<FormStateResponse>) { (Object as any).assign(this, init); }
}

export class UserPermissionsResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public permissions?: BctUserPermissionContext[];

    public constructor(init?: Partial<UserPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class HasOpmsPermissionCollectionResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public hasPermission?: { [index:number]: boolean; };

    public constructor(init?: Partial<HasOpmsPermissionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelEmailAddressesResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public emailAddresses?: MailAddress[];

    public constructor(init?: Partial<InstitutionPersonnelEmailAddressesResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public personnel?: { [index:number]: InstitutionPersonnel; };

    public constructor(init?: Partial<InstitutionPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelNamesResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public personnelNames?: { [index:number]: string; };

    public constructor(init?: Partial<InstitutionPersonnelNamesResponse>) { (Object as any).assign(this, init); }
}

export class TrialPersonnelActiveRoleResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public hasRole?: { [index:number]: boolean; };

    public constructor(init?: Partial<TrialPersonnelActiveRoleResponse>) { (Object as any).assign(this, init); }
}

export class UserPersonnelEmailAddressResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public emailAddress?: MailAddress;

    public constructor(init?: Partial<UserPersonnelEmailAddressResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteProtocolResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public protocolName?: string;
    public protocolVersion?: string;
    public usingNewProtocol: boolean;

    public constructor(init?: Partial<GetSiteProtocolResponse>) { (Object as any).assign(this, init); }
}

export class CheckAnyOpmsInstitutionOnNewProtocolResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public usingNewProtocol: boolean;

    public constructor(init?: Partial<CheckAnyOpmsInstitutionOnNewProtocolResponse>) { (Object as any).assign(this, init); }
}

export class GetCachedFormDefinitions implements IReturn<CachedFormDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedFormDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedFormDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedFormDefinitionCollectionResponse(); }
}

export class GetCachedEventDefinitions implements IReturn<CachedEventDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedEventDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedEventDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedEventDefinitionCollectionResponse(); }
}

export class GetCachedPatientStates implements IReturn<CachedPatientStateCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedPatientStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedPatientStates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedPatientStateCollectionResponse(); }
}

export class GetCachedTreatments implements IReturn<CachedTreatmentCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedTreatments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedTreatments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedTreatmentCollectionResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class StartConsentForm implements IReturn<StartConsentFormResponse>, IPost, IConsentFormConfigurationRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public formDefinitionId?: number;

    // @DataMember(Order=3)
    public workflow?: ConsentWorkflow;

    // @DataMember(Order=4)
    public participantFirstName?: string;

    // @DataMember(Order=5)
    public participantLastName?: string;

    // @DataMember(Order=6)
    public participantEmailAddress?: string;

    // @DataMember(Order=7)
    public assignedInvestigatorUsername?: string;

    // @DataMember(Order=8)
    public assignedInvestigatorSpecify?: string;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    public constructor(init?: Partial<StartConsentForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartConsentForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartConsentFormResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class RestartConsentForm implements IReturn<RestartConsentFormResponse>, IPost, IConsentFormConfigurationRequest
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public formDefinitionId?: number;

    // @DataMember(Order=3)
    public workflow?: ConsentWorkflow;

    // @DataMember(Order=4)
    public participantFirstName?: string;

    // @DataMember(Order=5)
    public participantLastName?: string;

    // @DataMember(Order=6)
    public participantEmailAddress?: string;

    // @DataMember(Order=7)
    public assignedInvestigatorUsername?: string;

    // @DataMember(Order=8)
    public assignedInvestigatorSpecify?: string;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    public constructor(init?: Partial<RestartConsentForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RestartConsentForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RestartConsentFormResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class CompleteConsentForm implements IReturn<CompleteConsentFormResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public formDefinitionId?: number;

    public constructor(init?: Partial<CompleteConsentForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CompleteConsentForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CompleteConsentFormResponse(); }
}

// @DataContract
export class GetConsentVersions implements IReturn<GetConsentVersionsResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public institutionCode?: string;

    // @DataMember(Order=2)
    public picfTypeName?: string;

    public constructor(init?: Partial<GetConsentVersions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConsentVersions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConsentVersionsResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class QueueConsentInformationEmail implements IReturn<QueueConsentInformationEmailResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    public constructor(init?: Partial<QueueConsentInformationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueConsentInformationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueConsentInformationEmailResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class QueueEConsentPatientEmail implements IReturn<QueueEConsentPatientEmailResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public formDefinitionId?: number;

    public constructor(init?: Partial<QueueEConsentPatientEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueEConsentPatientEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueEConsentPatientEmailResponse(); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class QueueEConsentPatientCompleteEmail implements IReturn<QueueEConsentPatientCompleteEmailResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public formDefinitionId?: number;

    public constructor(init?: Partial<QueueEConsentPatientCompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueEConsentPatientCompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueEConsentPatientCompleteEmailResponse(); }
}

export class DummyRequest implements IReturnVoid
{
    [immerable]? = true;

    public patientStateType: PatientStateType;
    public eventDefinitionType: EventDefinitionType;
    public formDefinitionType: FormDefinitionType;
    public lookupYesNoType: LookupYesNoType;
    public file?: File;

    public constructor(init?: Partial<DummyRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DummyRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

export class SendConsentInformationEmail implements IReturn<SendConsentInformationEmailResponse>
{
    [immerable]? = true;

    public participantEmail?: string;
    public instCode?: string;

    public constructor(init?: Partial<SendConsentInformationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendConsentInformationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendConsentInformationEmailResponse(); }
}

export class SendEConsentPatientEmail implements IReturn<SendEConsentPatientEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;

    public constructor(init?: Partial<SendEConsentPatientEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentPatientEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentPatientEmailResponse(); }
}

export class SendEConsentPatientCompleteEmail implements IReturn<SendEConsentPatientCompleteEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;

    public constructor(init?: Partial<SendEConsentPatientCompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentPatientCompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentPatientCompleteEmailResponse(); }
}

export class SendEConsentCompleteTrialEmail implements IReturn<SendEConsentCompleteTrialEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;

    public constructor(init?: Partial<SendEConsentCompleteTrialEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentCompleteTrialEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentCompleteTrialEmailResponse(); }
}

export class SendEConsentCompleteEmail implements IReturn<SendEConsentCompleteEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;

    public constructor(init?: Partial<SendEConsentCompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentCompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentCompleteEmailResponse(); }
}

// @Route("/econsent/main-consent/{Guid}", "GET")
// @Api(Description="eConsent - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormGetResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormGetResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormGetResponse)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentFormGet implements IReturn<MainConsentFormEConsentFormGetResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<MainConsentFormEConsentFormGet>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentFormGet'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormEConsentFormGetResponse(); }
}

// @Route("/econsent/main-consent/{Guid}/picf", "GET")
// @Api(Description="eConsent - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(System.IO.Stream)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(System.IO.Stream)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(System.IO.Stream)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentFormGetPicf implements IReturn<Blob>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<MainConsentFormEConsentFormGetPicf>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentFormGetPicf'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/econsent/main-consent/{Guid}/validate", "POST")
// @Api(Description="eConsent - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormValidationResponse)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentFormPostValidate implements IReturn<MainConsentFormEConsentFormValidationResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: MainConsentFormEConsentPatientForm;

    public constructor(init?: Partial<MainConsentFormEConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormEConsentFormValidationResponse(); }
}

// @Route("/econsent/main-consent/{Guid}/submit", "POST")
// @Api(Description="eConsent - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentFormSubmitResponse)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentFormPostSubmit implements IReturn<MainConsentFormEConsentFormSubmitResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: MainConsentFormEConsentPatientForm;

    public constructor(init?: Partial<MainConsentFormEConsentFormPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentFormPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormEConsentFormSubmitResponse(); }
}

// @Route("/econsent/main-consent/investigator/{PatientId}/validate", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorValidationResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorValidationResponse)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentInvestigatorPostValidate implements IReturn<MainConsentFormEConsentInvestigatorValidationResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: MainConsentForm;

    public constructor(init?: Partial<MainConsentFormEConsentInvestigatorPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentInvestigatorPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormEConsentInvestigatorValidationResponse(); }
}

// @Route("/econsent/main-consent/investigator/{PatientId}/submit", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - MainConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.MainConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=400)
// @DataContract
export class MainConsentFormEConsentInvestigatorPostSubmit implements IReturn<MainConsentFormEConsentInvestigatorSubmitResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: MainConsentForm;

    public constructor(init?: Partial<MainConsentFormEConsentInvestigatorPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormEConsentInvestigatorPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormEConsentInvestigatorSubmitResponse(); }
}

// @Route("/econsent/optional-consent/{Guid}", "GET")
// @Api(Description="eConsent - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormGetResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormGetResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormGetResponse)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentFormGet implements IReturn<OptionalConsentFormEConsentFormGetResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormGet>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentFormGet'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormEConsentFormGetResponse(); }
}

// @Route("/econsent/optional-consent/{Guid}/picf", "GET")
// @Api(Description="eConsent - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(System.IO.Stream)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(System.IO.Stream)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(System.IO.Stream)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentFormGetPicf implements IReturn<Blob>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormGetPicf>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentFormGetPicf'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/econsent/optional-consent/{Guid}/validate", "POST")
// @Api(Description="eConsent - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormValidationResponse)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentFormPostValidate implements IReturn<OptionalConsentFormEConsentFormValidationResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: OptionalConsentFormEConsentPatientForm;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormEConsentFormValidationResponse(); }
}

// @Route("/econsent/optional-consent/{Guid}/submit", "POST")
// @Api(Description="eConsent - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentFormSubmitResponse)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentFormPostSubmit implements IReturn<OptionalConsentFormEConsentFormSubmitResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: OptionalConsentFormEConsentPatientForm;

    public constructor(init?: Partial<OptionalConsentFormEConsentFormPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentFormPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormEConsentFormSubmitResponse(); }
}

// @Route("/econsent/optional-consent/investigator/{PatientId}/validate", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorValidationResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorValidationResponse)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentInvestigatorPostValidate implements IReturn<OptionalConsentFormEConsentInvestigatorValidationResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: OptionalConsentForm;

    public constructor(init?: Partial<OptionalConsentFormEConsentInvestigatorPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentInvestigatorPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormEConsentInvestigatorValidationResponse(); }
}

// @Route("/econsent/optional-consent/investigator/{PatientId}/submit", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - OptionalConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.OptionalConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=400)
// @DataContract
export class OptionalConsentFormEConsentInvestigatorPostSubmit implements IReturn<OptionalConsentFormEConsentInvestigatorSubmitResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: OptionalConsentForm;

    public constructor(init?: Partial<OptionalConsentFormEConsentInvestigatorPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormEConsentInvestigatorPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormEConsentInvestigatorSubmitResponse(); }
}

// @Route("/econsent/services-australia-consent/{Guid}", "GET")
// @Api(Description="eConsent - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormGetResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormGetResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormGetResponse)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentFormGet implements IReturn<ServicesAustraliaConsentFormEConsentFormGetResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormGet>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentFormGet'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormEConsentFormGetResponse(); }
}

// @Route("/econsent/services-australia-consent/{Guid}/picf", "GET")
// @Api(Description="eConsent - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(System.IO.Stream)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(System.IO.Stream)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(System.IO.Stream)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentFormGetPicf implements IReturn<Blob>, IEConsentRequest, IGet
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormGetPicf>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentFormGetPicf'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/econsent/services-australia-consent/{Guid}/validate", "POST")
// @Api(Description="eConsent - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormValidationResponse)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentFormPostValidate implements IReturn<ServicesAustraliaConsentFormEConsentFormValidationResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentFormEConsentPatientForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormEConsentFormValidationResponse(); }
}

// @Route("/econsent/services-australia-consent/{Guid}/submit", "POST")
// @Api(Description="eConsent - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentFormSubmitResponse)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentFormPostSubmit implements IReturn<ServicesAustraliaConsentFormEConsentFormSubmitResponse>, IEConsentRequest, IPost
{
    [immerable]? = true;

    /** @description The participant access GUID. */
    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentFormEConsentPatientForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentFormPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentFormPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormEConsentFormSubmitResponse(); }
}

// @Route("/econsent/services-australia-consent/investigator/{PatientId}/validate", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentInvestigatorPostValidate implements IReturn<ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentInvestigatorPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentInvestigatorPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormEConsentInvestigatorValidationResponse(); }
}

// @Route("/econsent/services-australia-consent/investigator/{PatientId}/submit", "POST")
// @ValidateRequest(Validator="IsAuthenticated")
// @Api(Description="eConsent investigator - ServicesAustraliaConsentForm")
// @ApiResponse(Description="The eConsent form was not found.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=404)
// @ApiResponse(Description="Only the assigned investigator can complete the eConsent form.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=403)
// @ApiResponse(Description="The eConsent form cannot be submitted from its current state.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=409)
// @ApiResponse(Description="The eConsent form is invalid.", ResponseType="typeof(__EConsentForm.ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse)", StatusCode=400)
// @DataContract
export class ServicesAustraliaConsentFormEConsentInvestigatorPostSubmit implements IReturn<ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient ID. */
    // @DataMember(Order=1)
    public patientId: number;

    // @DataMember(Order=2)
    public form?: ServicesAustraliaConsentForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormEConsentInvestigatorPostSubmit>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormEConsentInvestigatorPostSubmit'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormEConsentInvestigatorSubmitResponse(); }
}

// @Route("/opms/invitation/institutions", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInstitutions implements IReturn<GetInstitutionsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetInstitutions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionsResponse(); }
}

// @Route("/opms/invitation/investigators", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInvestigators implements IReturn<GetInvestigatorsResponse>, IGet
{
    [immerable]? = true;

    public institutionCode?: string;

    public constructor(init?: Partial<GetInvestigators>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvestigators'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvestigatorsResponse(); }
}

// @Route("/opms/picf/{InstCode}/{PatientConsentId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetPicfs implements IReturn<GetPicfsResponse>, IGet
{
    [immerable]? = true;

    public instCode?: string;
    public patientConsentId?: number;

    public constructor(init?: Partial<GetPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPicfsResponse(); }
}

// @Route("/opms/picf/download/{InstCode}/{PicfIdOne}/{PicfTypeIdOne}/{PicfIdTwo}/{PicfTypeIdTwo}/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadTwoPicfs implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode?: string;
    public picfIdOne?: number;
    public picfTypeIdOne?: number;
    public picfIdTwo?: number;
    public picfTypeIdTwo?: number;

    public constructor(init?: Partial<GetDownloadTwoPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadTwoPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/picf/{InstCode}/type/{PicfTypeName}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetPicfVersions implements IReturn<GetPicfVersionsResponse>, IGet
{
    [immerable]? = true;

    public instCode?: string;
    public picfTypeName?: string;

    public constructor(init?: Partial<GetPicfVersions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPicfVersions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPicfVersionsResponse(); }
}

// @Route("/opms/picf/download/all/{InstCode}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadPicfs implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode?: string;

    public constructor(init?: Partial<GetDownloadPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/picf/download/{InstCode}/{PicfId}/{PicfTypeId}/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadPicf implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode?: string;
    public picfId?: number;
    public picfTypeId?: number;

    public constructor(init?: Partial<GetDownloadPicf>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadPicf'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/consentpending/single/id/{Id}", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetSingleById implements IReturn<ConsentPendingSingleResponse>, IConsentPendingGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the consentpending to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<ConsentPendingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingSingleResponse(); }
}

// @Route("/opms/consentpending/collection", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetCollection implements IReturn<ConsentPendingCollectionResponse>, IConsentPendingGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ConsentPendingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingCollectionResponse(); }
}

// @Route("/opms/consentpending/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetCollectionByInstitutionCode implements IReturn<ConsentPendingCollectionResponse>, IConsentPendingGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The institution code of the consentpending to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<ConsentPendingGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingCollectionResponse(); }
}

// @Route("/opms/consentpending/save", "POST")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingPostSave implements IReturn<ConsentPendingSingleResponse>
{
    [immerable]? = true;

    /** @description The consentpending to save. */
    // @DataMember(Order=1)
    public consentPending: ConsentPending;

    /** @description The consentpending to save. */
    // @DataMember(Order=2)
    public invitationGuid: string;

    public constructor(init?: Partial<ConsentPendingPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsentPendingSingleResponse(); }
}

// @Route("/opms/consentpending/delete/{Id}", "DELETE")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingDelete implements IReturn<ConsentPendingDeleteResponse>, IConsentPendingDelete
{
    [immerable]? = true;

    /** @description The consentpending ID to delete. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<ConsentPendingDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ConsentPendingDeleteResponse(); }
}

// @Route("/opms/consentpending/save-status", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class ConsentPendingSaveStatus implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;
    public statusId?: StatusTypeEnum;

    public constructor(init?: Partial<ConsentPendingSaveStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingSaveStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/consentpending/resend-email", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class ConsentPendingResendEmail implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<ConsentPendingResendEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingResendEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patientconsent/single/id/{Id}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetSingleById implements IReturn<PatientConsentSingleResponse>, IPatientConsentGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<PatientConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/single/guid/{Guid}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetSingleByGuid implements IReturn<PatientConsentSingleResponse>, IPatientConsentGetSingleByGuid
{
    [immerable]? = true;

    /** @description The guid of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<PatientConsentGetSingleByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetSingleByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/collection", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetCollection implements IReturn<PatientConsentCollectionResponse>, IPatientConsentGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentCollectionResponse(); }
}

// @Route("/opms/patientconsent/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetCollectionByInstitutionCode implements IReturn<PatientConsentCollectionResponse>, IPatientConsentGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The institution code of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<PatientConsentGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentCollectionResponse(); }
}

// @Route("/opms/patientconsent/save", "POST")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentPostSave implements IReturn<PatientConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The patientconsent to save. */
    // @DataMember(Order=1)
    public patientConsent: PatientConsent;

    /** @description The patientconsent to check. */
    // @DataMember(Order=1)
    public emailRequired: boolean;

    public constructor(init?: Partial<PatientConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/delete/{Id}", "DELETE")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class PatientConsentDelete implements IReturn<PatientConsentDeleteResponse>, IPatientConsentDelete
{
    [immerable]? = true;

    /** @description The patientconsent ID to delete. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<PatientConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientConsentDeleteResponse(); }
}

// @Route("/opms/patient-consent/save-status", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSaveStatus implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;
    public statusId?: StatusTypeEnum;

    public constructor(init?: Partial<PatientConsentSaveStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSaveStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patient-consent/send-reminder", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendReminder implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<PatientConsentSendReminder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendReminder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patient-consent/send-verification-code", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendVerificationCode implements IReturn<PatientConsentSendVerificationCodeResponse>, IPost
{
    [immerable]? = true;

    public phoneNumber?: string;

    public constructor(init?: Partial<PatientConsentSendVerificationCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendVerificationCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientConsentSendVerificationCodeResponse(); }
}

// @Route("/opms/patient-consent/view-consent-file/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentViewConsentFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<PatientConsentViewConsentFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentViewConsentFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/patient-consent/information", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendInformationEmail implements IReturnVoid, IPost
{
    [immerable]? = true;

    public email?: string;
    public instCode?: string;

    public constructor(init?: Partial<PatientConsentSendInformationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendInformationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable]? = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider?: string;

    // @DataMember(Order=2)
    public userName?: string;

    // @DataMember(Order=3)
    public password?: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken?: string;

    // @DataMember(Order=6)
    public accessTokenSecret?: string;

    // @DataMember(Order=7)
    public returnUrl?: string;

    // @DataMember(Order=8)
    public errorView?: string;

    // @DataMember(Order=9)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName?: string;

    // @DataMember(Order=2)
    public permissions?: string[];

    // @DataMember(Order=3)
    public roles?: string[];

    // @DataMember(Order=4)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment?: string;

    // @DataMember(Order=2)
    public meta?: { [index:string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @DataContract
export class FormValidationById implements IReturn<FormValidationByIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    // @DataMember(Order=3)
    public eventRepeat?: number;

    // @DataMember(Order=4)
    public formDefinitionId?: number;

    // @DataMember(Order=5)
    public formRepeat?: number;

    public constructor(init?: Partial<FormValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormValidationById'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FormValidationByIdResponse(); }
}

// @Route("/opms/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable]? = true;


    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/user")
export class GetUser implements IReturn<GetUserResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

// @Route("/opms/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable]? = true;

    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/opms/form-names")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/opms/event-definition/single/id/{Id}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleById implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/single/code/{Code}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleByCode implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<EventDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/collection", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetCollection implements IReturn<EventDefinitionCollectionResponse>, IEventDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionCollectionResponse(); }
}

// @Route("/opms/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IFormDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/opms/patient-state/single/id/{Id}", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetSingleById implements IReturn<PatientStateSingleResponse>, IPatientStateGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient state to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientStateGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateSingleResponse(); }
}

// @Route("/opms/patient-state/collection", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetCollection implements IReturn<PatientStateCollectionResponse>, IPatientStateGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientStateGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateCollectionResponse(); }
}

// @Route("/opms/treatment/single/id/{Id}", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetSingleById implements IReturn<TreatmentSingleResponse>, ITreatmentGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentSingleResponse(); }
}

// @Route("/opms/treatment/collection", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetCollection implements IReturn<TreatmentCollectionResponse>, ITreatmentGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TreatmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentCollectionResponse(); }
}

// @Route("/opms/master-group/single/id/{Id}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleById implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/single/code/{Code}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByCode implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<MasterGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/collection", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollection implements IReturn<MasterGroupCollectionResponse>, IMasterGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MasterGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/single/id/{Id}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleById implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CollaboratingGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/single/code/{Code}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleByCode implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<CollaboratingGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/collection", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollection implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CollaboratingGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupId implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupCode implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode?: string;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/country/single/id/{Id}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleById implements IReturn<CountrySingleResponse>, ICountryGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/single/code/{Code}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByCode implements IReturn<CountrySingleResponse>, ICountryGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<CountryGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/collection", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollection implements IReturn<CountryCollectionResponse>, ICountryGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CountryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode?: string;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode?: string;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/institution/single/id/{Id}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/single/code/{Code}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByCode implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public code?: string;

    public constructor(init?: Partial<InstitutionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/collection", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/id/{CountryId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryCode?: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode?: string;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode?: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/patient/single/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IPatientGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/single/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber?: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/validation/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationById implements IReturn<PatientValidationResponse>, IPatientGetValidationById
{
    [immerable]? = true;

    /** @description The ID of the patient to validate. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/validation/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationByStudyNumber implements IReturn<PatientValidationResponse>, IPatientGetValidationByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to validate. */
    // @DataMember(Order=1)
    public studyNumber?: string;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/collection", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IPatientGetCollection
{
    [immerable]? = true;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/id/{CountryId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/id/{InstitutionId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionId
{
    [immerable]? = true;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode?: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode?: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/code/{InstitutionCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The Code of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds?: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/Save", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSave implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    public constructor(init?: Partial<PatientPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/ids", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithIds implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    public constructor(init?: Partial<PatientPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/codes", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithCodes implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    public constructor(init?: Partial<PatientPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/event/validation/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=500)
// @DataContract
export class EventGetValidationByIds implements IReturn<EventValidationResponse>, IEventGetValidationByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to validate. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to validate. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the event to validate. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description Whether to only run the event validator or to validate all forms as well. */
    // @DataMember(Order=4)
    public eventOnly?: boolean;

    public constructor(init?: Partial<EventGetValidationByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetValidationByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventValidationResponse(); }
}

// @Route("/opms/event/single/id/{Id}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleById implements IReturn<EventSingleResponse>, IEventGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/ids", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByIds implements IReturn<EventSingleResponse>, IEventGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Id of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/codes", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByCodes implements IReturn<EventSingleResponse>, IEventGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Code of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/collection", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollection implements IReturn<EventCollectionResponse>, IEventGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/id/{PatientId}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientId implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientId
{
    [immerable]? = true;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    public constructor(init?: Partial<EventGetCollectionByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/study-number/{PatientStudyNumber}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientStudyNumber implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    public constructor(init?: Partial<EventGetCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/Save", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSave implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    public constructor(init?: Partial<EventPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/ids", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithIds implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The ID of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/codes", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithCodes implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The Code of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/single/id/{Id}", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetSingleById implements IReturn<CommentsAndIssuesEventFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/single/ids", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetSingleByIds implements IReturn<CommentsAndIssuesEventFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new comments and issues event form if no comments and issues event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesEventFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/single/codes", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetSingleByCodes implements IReturn<CommentsAndIssuesEventFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new comments and issues event form if no comments and issues event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesEventFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/collection", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetCollection implements IReturn<CommentsAndIssuesEventFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CommentsAndIssuesEventFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetCollectionByIds implements IReturn<CommentsAndIssuesEventFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormGetCollectionByCodes implements IReturn<CommentsAndIssuesEventFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesEventFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/save", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostSave implements IReturn<CommentsAndIssuesEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/save/ids", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostSaveWithIds implements IReturn<CommentsAndIssuesEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    /** @description The ID of the Institution associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/save/codes", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostSaveWithCodes implements IReturn<CommentsAndIssuesEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    /** @description The Code of the Institution associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/delete", "DELETE")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormDelete implements IReturn<CommentsAndIssuesEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to delete. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    public constructor(init?: Partial<CommentsAndIssuesEventFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesEventFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormDeleteWithId implements IReturn<CommentsAndIssuesEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesEventFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/delete/ids", "DELETE")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormDeleteWithIds implements IReturn<CommentsAndIssuesEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesEventFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/delete/codes", "DELETE")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormDeleteByCodes implements IReturn<CommentsAndIssuesEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the comments and issues event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesEventFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/validate", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostValidate implements IReturn<CommentsAndIssuesEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/validate/ids", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostValidateWithIds implements IReturn<CommentsAndIssuesEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    /** @description The ID of the Institution associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/validate/codes", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostValidateWithCodes implements IReturn<CommentsAndIssuesEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues event form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesEventForm;

    /** @description The Code of the Institution associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-event-form/update-status/", "POST")
// @Api(Description="Form - Comments And Issues Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesEventFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesEventFormPostUpdateStatusByIds implements IReturn<CommentsAndIssuesEventFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the comments and issues event form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the comments and issues event form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the comments and issues event form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the comments and issues event form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the comments and issues event form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<CommentsAndIssuesEventFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesEventFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesEventFormUpdateStatusResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/single/id/{Id}", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetSingleById implements IReturn<CommentsAndIssuesFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/single/ids", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetSingleByIds implements IReturn<CommentsAndIssuesFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new comments and issues form if no comments and issues form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/single/codes", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetSingleByCodes implements IReturn<CommentsAndIssuesFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new comments and issues form if no comments and issues form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/collection", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetCollection implements IReturn<CommentsAndIssuesFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CommentsAndIssuesFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetCollectionByIds implements IReturn<CommentsAndIssuesFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormCollectionResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormGetCollectionByCodes implements IReturn<CommentsAndIssuesFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CommentsAndIssuesFormCollectionResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/save", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostSave implements IReturn<CommentsAndIssuesFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    public constructor(init?: Partial<CommentsAndIssuesFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/save/ids", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostSaveWithIds implements IReturn<CommentsAndIssuesFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    /** @description The ID of the Institution associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/save/codes", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormSingleResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostSaveWithCodes implements IReturn<CommentsAndIssuesFormSingleResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to save. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    /** @description The Code of the Institution associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CommentsAndIssuesFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormSingleResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/delete", "DELETE")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormDelete implements IReturn<CommentsAndIssuesFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to delete. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    public constructor(init?: Partial<CommentsAndIssuesFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormDeleteWithId implements IReturn<CommentsAndIssuesFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/delete/ids", "DELETE")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormDeleteWithIds implements IReturn<CommentsAndIssuesFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/delete/codes", "DELETE")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormDeleteResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormDeleteByCodes implements IReturn<CommentsAndIssuesFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the comments and issues form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CommentsAndIssuesFormDeleteResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/validate", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostValidate implements IReturn<CommentsAndIssuesFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    public constructor(init?: Partial<CommentsAndIssuesFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/validate/ids", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostValidateWithIds implements IReturn<CommentsAndIssuesFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    /** @description The ID of the Institution associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/validate/codes", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormValidationResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostValidateWithCodes implements IReturn<CommentsAndIssuesFormValidationResponse>
{
    [immerable]? = true;

    /** @description The comments and issues form to validate. */
    // @DataMember(Order=1)
    public form: CommentsAndIssuesForm;

    /** @description The Code of the Institution associated with the comments and issues form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the comments and issues form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the comments and issues form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the comments and issues form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CommentsAndIssuesFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormValidationResponse(); }
}

// @Route("/opms/form/comments-and-issues-form/update-status/", "POST")
// @Api(Description="Form - Comments And Issues Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CommentsAndIssuesFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class CommentsAndIssuesFormPostUpdateStatusByIds implements IReturn<CommentsAndIssuesFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the comments and issues form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the comments and issues form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the comments and issues form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the comments and issues form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the comments and issues form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<CommentsAndIssuesFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CommentsAndIssuesFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CommentsAndIssuesFormUpdateStatusResponse(); }
}

// @Route("/opms/form/main-consent-form/single/id/{Id}", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetSingleById implements IReturn<MainConsentFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MainConsentFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/single/ids", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetSingleByIds implements IReturn<MainConsentFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the main consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new main consent form if no main consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MainConsentFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/single/codes", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetSingleByCodes implements IReturn<MainConsentFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the main consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new main consent form if no main consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MainConsentFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/collection", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetCollection implements IReturn<MainConsentFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MainConsentFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormCollectionResponse(); }
}

// @Route("/opms/form/main-consent-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetCollectionByIds implements IReturn<MainConsentFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormCollectionResponse(); }
}

// @Route("/opms/form/main-consent-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormGetCollectionByCodes implements IReturn<MainConsentFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentFormCollectionResponse(); }
}

// @Route("/opms/form/main-consent-form/save", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostSave implements IReturn<MainConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent form to save. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    public constructor(init?: Partial<MainConsentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/save/ids", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostSaveWithIds implements IReturn<MainConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent form to save. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    /** @description The ID of the Institution associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MainConsentFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/save/codes", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostSaveWithCodes implements IReturn<MainConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent form to save. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    /** @description The Code of the Institution associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the main consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MainConsentFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent-form/delete", "DELETE")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormDelete implements IReturn<MainConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The main consent form to delete. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    public constructor(init?: Partial<MainConsentFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentFormDeleteResponse(); }
}

// @Route("/opms/form/main-consent-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormDeleteWithId implements IReturn<MainConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MainConsentFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentFormDeleteResponse(); }
}

// @Route("/opms/form/main-consent-form/delete/ids", "DELETE")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormDeleteWithIds implements IReturn<MainConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MainConsentFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentFormDeleteResponse(); }
}

// @Route("/opms/form/main-consent-form/delete/codes", "DELETE")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormDeleteByCodes implements IReturn<MainConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the main consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MainConsentFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentFormDeleteResponse(); }
}

// @Route("/opms/form/main-consent-form/validate", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostValidate implements IReturn<MainConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent form to validate. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    public constructor(init?: Partial<MainConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormValidationResponse(); }
}

// @Route("/opms/form/main-consent-form/validate/ids", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostValidateWithIds implements IReturn<MainConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent form to validate. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    /** @description The ID of the Institution associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormValidationResponse(); }
}

// @Route("/opms/form/main-consent-form/validate/codes", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostValidateWithCodes implements IReturn<MainConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent form to validate. */
    // @DataMember(Order=1)
    public form: MainConsentForm;

    /** @description The Code of the Institution associated with the main consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the main consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the main consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormValidationResponse(); }
}

// @Route("/opms/form/main-consent-form/update-status/", "POST")
// @Api(Description="Form - Main Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class MainConsentFormPostUpdateStatusByIds implements IReturn<MainConsentFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the main consent form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the main consent form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the main consent form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the main consent form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the main consent form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<MainConsentFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentFormUpdateStatusResponse(); }
}

// @Route("/opms/form/optional-consent-form/single/id/{Id}", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetSingleById implements IReturn<OptionalConsentFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<OptionalConsentFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/single/ids", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetSingleByIds implements IReturn<OptionalConsentFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new optional consent form if no optional consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<OptionalConsentFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/single/codes", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetSingleByCodes implements IReturn<OptionalConsentFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new optional consent form if no optional consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<OptionalConsentFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/collection", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetCollection implements IReturn<OptionalConsentFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<OptionalConsentFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormCollectionResponse(); }
}

// @Route("/opms/form/optional-consent-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetCollectionByIds implements IReturn<OptionalConsentFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormCollectionResponse(); }
}

// @Route("/opms/form/optional-consent-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormGetCollectionByCodes implements IReturn<OptionalConsentFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new OptionalConsentFormCollectionResponse(); }
}

// @Route("/opms/form/optional-consent-form/save", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostSave implements IReturn<OptionalConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to save. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    public constructor(init?: Partial<OptionalConsentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/save/ids", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostSaveWithIds implements IReturn<OptionalConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to save. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    /** @description The ID of the Institution associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<OptionalConsentFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/save/codes", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostSaveWithCodes implements IReturn<OptionalConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to save. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    /** @description The Code of the Institution associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<OptionalConsentFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormSingleResponse(); }
}

// @Route("/opms/form/optional-consent-form/delete", "DELETE")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormDelete implements IReturn<OptionalConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to delete. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    public constructor(init?: Partial<OptionalConsentFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new OptionalConsentFormDeleteResponse(); }
}

// @Route("/opms/form/optional-consent-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormDeleteWithId implements IReturn<OptionalConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<OptionalConsentFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new OptionalConsentFormDeleteResponse(); }
}

// @Route("/opms/form/optional-consent-form/delete/ids", "DELETE")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormDeleteWithIds implements IReturn<OptionalConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new OptionalConsentFormDeleteResponse(); }
}

// @Route("/opms/form/optional-consent-form/delete/codes", "DELETE")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormDeleteByCodes implements IReturn<OptionalConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the optional consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new OptionalConsentFormDeleteResponse(); }
}

// @Route("/opms/form/optional-consent-form/validate", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostValidate implements IReturn<OptionalConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to validate. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    public constructor(init?: Partial<OptionalConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormValidationResponse(); }
}

// @Route("/opms/form/optional-consent-form/validate/ids", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostValidateWithIds implements IReturn<OptionalConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to validate. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    /** @description The ID of the Institution associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormValidationResponse(); }
}

// @Route("/opms/form/optional-consent-form/validate/codes", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostValidateWithCodes implements IReturn<OptionalConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The optional consent form to validate. */
    // @DataMember(Order=1)
    public form: OptionalConsentForm;

    /** @description The Code of the Institution associated with the optional consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the optional consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the optional consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the optional consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<OptionalConsentFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormValidationResponse(); }
}

// @Route("/opms/form/optional-consent-form/update-status/", "POST")
// @Api(Description="Form - Optional Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.OptionalConsentFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.OptionalConsentFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.OptionalConsentFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.OptionalConsentFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.OptionalConsentFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class OptionalConsentFormPostUpdateStatusByIds implements IReturn<OptionalConsentFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the optional consent form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the optional consent form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the optional consent form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the optional consent form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the optional consent form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<OptionalConsentFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'OptionalConsentFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new OptionalConsentFormUpdateStatusResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/single/id/{Id}", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetSingleById implements IReturn<PathologyTrackingEventFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/single/ids", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetSingleByIds implements IReturn<PathologyTrackingEventFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new pathology tracking event form if no pathology tracking event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PathologyTrackingEventFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/single/codes", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetSingleByCodes implements IReturn<PathologyTrackingEventFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new pathology tracking event form if no pathology tracking event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PathologyTrackingEventFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/collection", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetCollection implements IReturn<PathologyTrackingEventFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PathologyTrackingEventFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetCollectionByIds implements IReturn<PathologyTrackingEventFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormGetCollectionByCodes implements IReturn<PathologyTrackingEventFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingEventFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/save", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostSave implements IReturn<PathologyTrackingEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    public constructor(init?: Partial<PathologyTrackingEventFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/save/ids", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostSaveWithIds implements IReturn<PathologyTrackingEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    /** @description The ID of the Institution associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PathologyTrackingEventFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/save/codes", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostSaveWithCodes implements IReturn<PathologyTrackingEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    /** @description The Code of the Institution associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PathologyTrackingEventFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/delete", "DELETE")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormDelete implements IReturn<PathologyTrackingEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to delete. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    public constructor(init?: Partial<PathologyTrackingEventFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingEventFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormDeleteWithId implements IReturn<PathologyTrackingEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingEventFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/delete/ids", "DELETE")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormDeleteWithIds implements IReturn<PathologyTrackingEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingEventFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/delete/codes", "DELETE")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormDeleteByCodes implements IReturn<PathologyTrackingEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingEventFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/validate", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostValidate implements IReturn<PathologyTrackingEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    public constructor(init?: Partial<PathologyTrackingEventFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/validate/ids", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostValidateWithIds implements IReturn<PathologyTrackingEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    /** @description The ID of the Institution associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/validate/codes", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostValidateWithCodes implements IReturn<PathologyTrackingEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking event form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingEventForm;

    /** @description The Code of the Institution associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingEventFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-event-form/update-status/", "POST")
// @Api(Description="Form - Pathology Tracking Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingEventFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingEventFormPostUpdateStatusByIds implements IReturn<PathologyTrackingEventFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the pathology tracking event form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the pathology tracking event form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the pathology tracking event form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the pathology tracking event form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the pathology tracking event form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<PathologyTrackingEventFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingEventFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingEventFormUpdateStatusResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/single/id/{Id}", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetSingleById implements IReturn<PathologyTrackingFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PathologyTrackingFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/single/ids", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetSingleByIds implements IReturn<PathologyTrackingFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new pathology tracking form if no pathology tracking form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PathologyTrackingFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/single/codes", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetSingleByCodes implements IReturn<PathologyTrackingFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new pathology tracking form if no pathology tracking form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PathologyTrackingFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/collection", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetCollection implements IReturn<PathologyTrackingFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PathologyTrackingFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetCollectionByIds implements IReturn<PathologyTrackingFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormCollectionResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormGetCollectionByCodes implements IReturn<PathologyTrackingFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PathologyTrackingFormCollectionResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/save", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostSave implements IReturn<PathologyTrackingFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    public constructor(init?: Partial<PathologyTrackingFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/save/ids", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostSaveWithIds implements IReturn<PathologyTrackingFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    /** @description The ID of the Institution associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PathologyTrackingFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/save/codes", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormSingleResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostSaveWithCodes implements IReturn<PathologyTrackingFormSingleResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to save. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    /** @description The Code of the Institution associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PathologyTrackingFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormSingleResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/delete", "DELETE")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormDelete implements IReturn<PathologyTrackingFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to delete. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    public constructor(init?: Partial<PathologyTrackingFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormDeleteWithId implements IReturn<PathologyTrackingFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PathologyTrackingFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/delete/ids", "DELETE")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormDeleteWithIds implements IReturn<PathologyTrackingFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/delete/codes", "DELETE")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormDeleteResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormDeleteByCodes implements IReturn<PathologyTrackingFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the pathology tracking form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PathologyTrackingFormDeleteResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/validate", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostValidate implements IReturn<PathologyTrackingFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    public constructor(init?: Partial<PathologyTrackingFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/validate/ids", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostValidateWithIds implements IReturn<PathologyTrackingFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    /** @description The ID of the Institution associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/validate/codes", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormValidationResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostValidateWithCodes implements IReturn<PathologyTrackingFormValidationResponse>
{
    [immerable]? = true;

    /** @description The pathology tracking form to validate. */
    // @DataMember(Order=1)
    public form: PathologyTrackingForm;

    /** @description The Code of the Institution associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the pathology tracking form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PathologyTrackingFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormValidationResponse(); }
}

// @Route("/opms/form/pathology-tracking-form/update-status/", "POST")
// @Api(Description="Form - Pathology Tracking Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PathologyTrackingFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class PathologyTrackingFormPostUpdateStatusByIds implements IReturn<PathologyTrackingFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the pathology tracking form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the pathology tracking form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the pathology tracking form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the pathology tracking form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the pathology tracking form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<PathologyTrackingFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PathologyTrackingFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PathologyTrackingFormUpdateStatusResponse(); }
}

// @Route("/opms/form/randomisation-form/single/id/{Id}", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetSingleById implements IReturn<RandomisationFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RandomisationFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/single/ids", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetSingleByIds implements IReturn<RandomisationFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new randomisation form if no randomisation form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RandomisationFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/single/codes", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetSingleByCodes implements IReturn<RandomisationFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new randomisation form if no randomisation form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RandomisationFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/collection", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetCollection implements IReturn<RandomisationFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<RandomisationFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormCollectionResponse(); }
}

// @Route("/opms/form/randomisation-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetCollectionByIds implements IReturn<RandomisationFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RandomisationFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormCollectionResponse(); }
}

// @Route("/opms/form/randomisation-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormCollectionResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormGetCollectionByCodes implements IReturn<RandomisationFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RandomisationFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RandomisationFormCollectionResponse(); }
}

// @Route("/opms/form/randomisation-form/save", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostSave implements IReturn<RandomisationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to save. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    public constructor(init?: Partial<RandomisationFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/save/ids", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostSaveWithIds implements IReturn<RandomisationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to save. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    /** @description The ID of the Institution associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RandomisationFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/save/codes", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormSingleResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostSaveWithCodes implements IReturn<RandomisationFormSingleResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to save. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    /** @description The Code of the Institution associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RandomisationFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormSingleResponse(); }
}

// @Route("/opms/form/randomisation-form/delete", "DELETE")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormDelete implements IReturn<RandomisationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to delete. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    public constructor(init?: Partial<RandomisationFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RandomisationFormDeleteResponse(); }
}

// @Route("/opms/form/randomisation-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormDeleteWithId implements IReturn<RandomisationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RandomisationFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RandomisationFormDeleteResponse(); }
}

// @Route("/opms/form/randomisation-form/delete/ids", "DELETE")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormDeleteWithIds implements IReturn<RandomisationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RandomisationFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RandomisationFormDeleteResponse(); }
}

// @Route("/opms/form/randomisation-form/delete/codes", "DELETE")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormDeleteResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormDeleteByCodes implements IReturn<RandomisationFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the randomisation form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RandomisationFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RandomisationFormDeleteResponse(); }
}

// @Route("/opms/form/randomisation-form/validate", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostValidate implements IReturn<RandomisationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to validate. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    public constructor(init?: Partial<RandomisationFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormValidationResponse(); }
}

// @Route("/opms/form/randomisation-form/validate/ids", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostValidateWithIds implements IReturn<RandomisationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to validate. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    /** @description The ID of the Institution associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RandomisationFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormValidationResponse(); }
}

// @Route("/opms/form/randomisation-form/validate/codes", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormValidationResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostValidateWithCodes implements IReturn<RandomisationFormValidationResponse>
{
    [immerable]? = true;

    /** @description The randomisation form to validate. */
    // @DataMember(Order=1)
    public form: RandomisationForm;

    /** @description The Code of the Institution associated with the randomisation form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the randomisation form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the randomisation form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the randomisation form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RandomisationFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormValidationResponse(); }
}

// @Route("/opms/form/randomisation-form/update-status/", "POST")
// @Api(Description="Form - Randomisation Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RandomisationFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RandomisationFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RandomisationFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RandomisationFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RandomisationFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class RandomisationFormPostUpdateStatusByIds implements IReturn<RandomisationFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the randomisation form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the randomisation form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the randomisation form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the randomisation form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the randomisation form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<RandomisationFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RandomisationFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RandomisationFormUpdateStatusResponse(); }
}

// @Route("/opms/form/screening-form/single/id/{Id}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleById implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ScreeningFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/single/ids", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleByIds implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the screening form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new screening form if no screening form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ScreeningFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/single/codes", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleByCodes implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the screening form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new screening form if no screening form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ScreeningFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/collection", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollection implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ScreeningFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollectionByIds implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollectionByCodes implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/save", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSave implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/save/ids", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSaveWithIds implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The ID of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the screening form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ScreeningFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/save/codes", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSaveWithCodes implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The Code of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the screening form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ScreeningFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/delete", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDelete implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The screening form to delete. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteWithId implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ScreeningFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/ids", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteWithIds implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ScreeningFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/codes", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteByCodes implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ScreeningFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/validate", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidate implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/screening-form/validate/ids", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidateWithIds implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The ID of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/screening-form/validate/codes", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidateWithCodes implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The Code of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/screening-form/update-status/", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostUpdateStatusByIds implements IReturn<ScreeningFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the screening form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the screening form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the screening form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the screening form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the screening form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<ScreeningFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormUpdateStatusResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/single/id/{Id}", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetSingleById implements IReturn<ServicesAustraliaConsentFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/single/ids", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetSingleByIds implements IReturn<ServicesAustraliaConsentFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new services australia consent form if no services australia consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/single/codes", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetSingleByCodes implements IReturn<ServicesAustraliaConsentFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new services australia consent form if no services australia consent form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/collection", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetCollection implements IReturn<ServicesAustraliaConsentFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ServicesAustraliaConsentFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetCollectionByIds implements IReturn<ServicesAustraliaConsentFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormGetCollectionByCodes implements IReturn<ServicesAustraliaConsentFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentFormCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/save", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostSave implements IReturn<ServicesAustraliaConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/save/ids", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostSaveWithIds implements IReturn<ServicesAustraliaConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    /** @description The ID of the Institution associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/save/codes", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostSaveWithCodes implements IReturn<ServicesAustraliaConsentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    /** @description The Code of the Institution associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/delete", "DELETE")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormDelete implements IReturn<ServicesAustraliaConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to delete. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentFormDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormDeleteWithId implements IReturn<ServicesAustraliaConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentFormDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/delete/ids", "DELETE")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormDeleteWithIds implements IReturn<ServicesAustraliaConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentFormDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/delete/codes", "DELETE")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormDeleteByCodes implements IReturn<ServicesAustraliaConsentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the services australia consent form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentFormDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/validate", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostValidate implements IReturn<ServicesAustraliaConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/validate/ids", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostValidateWithIds implements IReturn<ServicesAustraliaConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    /** @description The ID of the Institution associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/validate/codes", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostValidateWithCodes implements IReturn<ServicesAustraliaConsentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent form to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsentForm;

    /** @description The Code of the Institution associated with the services australia consent form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the services australia consent form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the services australia consent form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent-form/update-status/", "POST")
// @Api(Description="Form - Services Australia Consent Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentFormPostUpdateStatusByIds implements IReturn<ServicesAustraliaConsentFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the services australia consent form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the services australia consent form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the services australia consent form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the services australia consent form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the services australia consent form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<ServicesAustraliaConsentFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentFormUpdateStatusResponse(); }
}

// @Route("/opms/form/source-document-form/single/id/{Id}", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetSingleById implements IReturn<SourceDocumentFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the source document form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/single/ids", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetSingleByIds implements IReturn<SourceDocumentFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the source document form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document form if no source document form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/single/codes", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetSingleByCodes implements IReturn<SourceDocumentFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the source document form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document form if no source document form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/collection", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetCollection implements IReturn<SourceDocumentFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SourceDocumentFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormCollectionResponse(); }
}

// @Route("/opms/form/source-document-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetCollectionByIds implements IReturn<SourceDocumentFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormCollectionResponse(); }
}

// @Route("/opms/form/source-document-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormGetCollectionByCodes implements IReturn<SourceDocumentFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentFormCollectionResponse(); }
}

// @Route("/opms/form/source-document-form/save", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostSave implements IReturn<SourceDocumentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The source document form to save. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    public constructor(init?: Partial<SourceDocumentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/save/ids", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostSaveWithIds implements IReturn<SourceDocumentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The source document form to save. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    /** @description The ID of the Institution associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/save/codes", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostSaveWithCodes implements IReturn<SourceDocumentFormSingleResponse>
{
    [immerable]? = true;

    /** @description The source document form to save. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    /** @description The Code of the Institution associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the source document form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormSingleResponse(); }
}

// @Route("/opms/form/source-document-form/delete", "DELETE")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormDelete implements IReturn<SourceDocumentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The source document form to delete. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    public constructor(init?: Partial<SourceDocumentFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentFormDeleteResponse(); }
}

// @Route("/opms/form/source-document-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormDeleteWithId implements IReturn<SourceDocumentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the source document form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentFormDeleteResponse(); }
}

// @Route("/opms/form/source-document-form/delete/ids", "DELETE")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormDeleteWithIds implements IReturn<SourceDocumentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentFormDeleteResponse(); }
}

// @Route("/opms/form/source-document-form/delete/codes", "DELETE")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormDeleteByCodes implements IReturn<SourceDocumentFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the source document form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentFormDeleteResponse(); }
}

// @Route("/opms/form/source-document-form/validate", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostValidate implements IReturn<SourceDocumentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The source document form to validate. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    public constructor(init?: Partial<SourceDocumentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormValidationResponse(); }
}

// @Route("/opms/form/source-document-form/validate/ids", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostValidateWithIds implements IReturn<SourceDocumentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The source document form to validate. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    /** @description The ID of the Institution associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormValidationResponse(); }
}

// @Route("/opms/form/source-document-form/validate/codes", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostValidateWithCodes implements IReturn<SourceDocumentFormValidationResponse>
{
    [immerable]? = true;

    /** @description The source document form to validate. */
    // @DataMember(Order=1)
    public form: SourceDocumentForm;

    /** @description The Code of the Institution associated with the source document form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the source document form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormValidationResponse(); }
}

// @Route("/opms/form/source-document-form/update-status/", "POST")
// @Api(Description="Form - Source Document Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentFormPostUpdateStatusByIds implements IReturn<SourceDocumentFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the source document form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the source document form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the source document form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the source document form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the source document form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<SourceDocumentFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentFormUpdateStatusResponse(); }
}

// @Route("/opms/form/status-event-form/single/id/{Id}", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetSingleById implements IReturn<StatusEventFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the status event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StatusEventFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/single/ids", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetSingleByIds implements IReturn<StatusEventFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the status event form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new status event form if no status event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<StatusEventFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/single/codes", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetSingleByCodes implements IReturn<StatusEventFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the status event form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new status event form if no status event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<StatusEventFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/collection", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetCollection implements IReturn<StatusEventFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<StatusEventFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormCollectionResponse(); }
}

// @Route("/opms/form/status-event-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetCollectionByIds implements IReturn<StatusEventFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusEventFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormCollectionResponse(); }
}

// @Route("/opms/form/status-event-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormGetCollectionByCodes implements IReturn<StatusEventFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusEventFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusEventFormCollectionResponse(); }
}

// @Route("/opms/form/status-event-form/save", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostSave implements IReturn<StatusEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status event form to save. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    public constructor(init?: Partial<StatusEventFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/save/ids", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostSaveWithIds implements IReturn<StatusEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status event form to save. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    /** @description The ID of the Institution associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the status event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<StatusEventFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/save/codes", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostSaveWithCodes implements IReturn<StatusEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status event form to save. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    /** @description The Code of the Institution associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the status event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the status event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<StatusEventFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormSingleResponse(); }
}

// @Route("/opms/form/status-event-form/delete", "DELETE")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormDelete implements IReturn<StatusEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The status event form to delete. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    public constructor(init?: Partial<StatusEventFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusEventFormDeleteResponse(); }
}

// @Route("/opms/form/status-event-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormDeleteWithId implements IReturn<StatusEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the status event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StatusEventFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusEventFormDeleteResponse(); }
}

// @Route("/opms/form/status-event-form/delete/ids", "DELETE")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormDeleteWithIds implements IReturn<StatusEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<StatusEventFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusEventFormDeleteResponse(); }
}

// @Route("/opms/form/status-event-form/delete/codes", "DELETE")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormDeleteByCodes implements IReturn<StatusEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the status event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<StatusEventFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusEventFormDeleteResponse(); }
}

// @Route("/opms/form/status-event-form/validate", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostValidate implements IReturn<StatusEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status event form to validate. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    public constructor(init?: Partial<StatusEventFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormValidationResponse(); }
}

// @Route("/opms/form/status-event-form/validate/ids", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostValidateWithIds implements IReturn<StatusEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status event form to validate. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    /** @description The ID of the Institution associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusEventFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormValidationResponse(); }
}

// @Route("/opms/form/status-event-form/validate/codes", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostValidateWithCodes implements IReturn<StatusEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status event form to validate. */
    // @DataMember(Order=1)
    public form: StatusEventForm;

    /** @description The Code of the Institution associated with the status event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the status event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the status event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the status event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusEventFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormValidationResponse(); }
}

// @Route("/opms/form/status-event-form/update-status/", "POST")
// @Api(Description="Form - Status Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusEventFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusEventFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusEventFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusEventFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusEventFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class StatusEventFormPostUpdateStatusByIds implements IReturn<StatusEventFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the status event form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the status event form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the status event form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the status event form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the status event form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<StatusEventFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusEventFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusEventFormUpdateStatusResponse(); }
}

// @Route("/opms/form/status-form/single/id/{Id}", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetSingleById implements IReturn<StatusFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the status form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StatusFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/single/ids", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetSingleByIds implements IReturn<StatusFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the status form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the status form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new status form if no status form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<StatusFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/single/codes", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetSingleByCodes implements IReturn<StatusFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the status form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the status form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new status form if no status form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<StatusFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/collection", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetCollection implements IReturn<StatusFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<StatusFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormCollectionResponse(); }
}

// @Route("/opms/form/status-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetCollectionByIds implements IReturn<StatusFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the status form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormCollectionResponse(); }
}

// @Route("/opms/form/status-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormCollectionResponse)", StatusCode=500)
// @DataContract
export class StatusFormGetCollectionByCodes implements IReturn<StatusFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the status form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new StatusFormCollectionResponse(); }
}

// @Route("/opms/form/status-form/save", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostSave implements IReturn<StatusFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status form to save. */
    // @DataMember(Order=1)
    public form: StatusForm;

    public constructor(init?: Partial<StatusFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/save/ids", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostSaveWithIds implements IReturn<StatusFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status form to save. */
    // @DataMember(Order=1)
    public form: StatusForm;

    /** @description The ID of the Institution associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the status form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the status form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<StatusFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/save/codes", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormSingleResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostSaveWithCodes implements IReturn<StatusFormSingleResponse>
{
    [immerable]? = true;

    /** @description The status form to save. */
    // @DataMember(Order=1)
    public form: StatusForm;

    /** @description The Code of the Institution associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the status form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the status form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<StatusFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormSingleResponse(); }
}

// @Route("/opms/form/status-form/delete", "DELETE")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusFormDelete implements IReturn<StatusFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The status form to delete. */
    // @DataMember(Order=1)
    public form: StatusForm;

    public constructor(init?: Partial<StatusFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusFormDeleteResponse(); }
}

// @Route("/opms/form/status-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusFormDeleteWithId implements IReturn<StatusFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the status form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<StatusFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusFormDeleteResponse(); }
}

// @Route("/opms/form/status-form/delete/ids", "DELETE")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusFormDeleteWithIds implements IReturn<StatusFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the status form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<StatusFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusFormDeleteResponse(); }
}

// @Route("/opms/form/status-form/delete/codes", "DELETE")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormDeleteResponse)", StatusCode=500)
// @DataContract
export class StatusFormDeleteByCodes implements IReturn<StatusFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the status form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the status form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<StatusFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new StatusFormDeleteResponse(); }
}

// @Route("/opms/form/status-form/validate", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostValidate implements IReturn<StatusFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status form to validate. */
    // @DataMember(Order=1)
    public form: StatusForm;

    public constructor(init?: Partial<StatusFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormValidationResponse(); }
}

// @Route("/opms/form/status-form/validate/ids", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostValidateWithIds implements IReturn<StatusFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status form to validate. */
    // @DataMember(Order=1)
    public form: StatusForm;

    /** @description The ID of the Institution associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the status form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormValidationResponse(); }
}

// @Route("/opms/form/status-form/validate/codes", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormValidationResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostValidateWithCodes implements IReturn<StatusFormValidationResponse>
{
    [immerable]? = true;

    /** @description The status form to validate. */
    // @DataMember(Order=1)
    public form: StatusForm;

    /** @description The Code of the Institution associated with the status form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the status form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the status form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the status form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<StatusFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormValidationResponse(); }
}

// @Route("/opms/form/status-form/update-status/", "POST")
// @Api(Description="Form - Status Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.StatusFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.StatusFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.StatusFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.StatusFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.StatusFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class StatusFormPostUpdateStatusByIds implements IReturn<StatusFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the status form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the status form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the status form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the status form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the status form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<StatusFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StatusFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StatusFormUpdateStatusResponse(); }
}

// @Route("/opms/form/transfer-event-form/single/id/{Id}", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetSingleById implements IReturn<TransferEventFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TransferEventFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/single/ids", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetSingleByIds implements IReturn<TransferEventFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new transfer event form if no transfer event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TransferEventFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/single/codes", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetSingleByCodes implements IReturn<TransferEventFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new transfer event form if no transfer event form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TransferEventFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/collection", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetCollection implements IReturn<TransferEventFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TransferEventFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-event-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetCollectionByIds implements IReturn<TransferEventFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferEventFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-event-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormGetCollectionByCodes implements IReturn<TransferEventFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferEventFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferEventFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-event-form/save", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostSave implements IReturn<TransferEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to save. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    public constructor(init?: Partial<TransferEventFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/save/ids", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostSaveWithIds implements IReturn<TransferEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to save. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    /** @description The ID of the Institution associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TransferEventFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/save/codes", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostSaveWithCodes implements IReturn<TransferEventFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to save. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    /** @description The Code of the Institution associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TransferEventFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormSingleResponse(); }
}

// @Route("/opms/form/transfer-event-form/delete", "DELETE")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormDelete implements IReturn<TransferEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to delete. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    public constructor(init?: Partial<TransferEventFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferEventFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-event-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormDeleteWithId implements IReturn<TransferEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TransferEventFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferEventFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-event-form/delete/ids", "DELETE")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormDeleteWithIds implements IReturn<TransferEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TransferEventFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferEventFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-event-form/delete/codes", "DELETE")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormDeleteByCodes implements IReturn<TransferEventFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the transfer event form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TransferEventFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferEventFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-event-form/validate", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostValidate implements IReturn<TransferEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to validate. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    public constructor(init?: Partial<TransferEventFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormValidationResponse(); }
}

// @Route("/opms/form/transfer-event-form/validate/ids", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostValidateWithIds implements IReturn<TransferEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to validate. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    /** @description The ID of the Institution associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferEventFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormValidationResponse(); }
}

// @Route("/opms/form/transfer-event-form/validate/codes", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostValidateWithCodes implements IReturn<TransferEventFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer event form to validate. */
    // @DataMember(Order=1)
    public form: TransferEventForm;

    /** @description The Code of the Institution associated with the transfer event form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the transfer event form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the transfer event form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the transfer event form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferEventFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormValidationResponse(); }
}

// @Route("/opms/form/transfer-event-form/update-status/", "POST")
// @Api(Description="Form - Transfer Event Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferEventFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferEventFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferEventFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferEventFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferEventFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class TransferEventFormPostUpdateStatusByIds implements IReturn<TransferEventFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the transfer event form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the transfer event form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the transfer event form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the transfer event form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the transfer event form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<TransferEventFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferEventFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferEventFormUpdateStatusResponse(); }
}

// @Route("/opms/form/transfer-form/single/id/{Id}", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetSingleById implements IReturn<TransferFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TransferFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/single/ids", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetSingleByIds implements IReturn<TransferFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the transfer form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new transfer form if no transfer form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TransferFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/single/codes", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetSingleByCodes implements IReturn<TransferFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the transfer form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode?: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new transfer form if no transfer form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TransferFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/collection", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetCollection implements IReturn<TransferFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TransferFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetCollectionByIds implements IReturn<TransferFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormCollectionResponse)", StatusCode=500)
// @DataContract
export class TransferFormGetCollectionByCodes implements IReturn<TransferFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TransferFormCollectionResponse(); }
}

// @Route("/opms/form/transfer-form/save", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostSave implements IReturn<TransferFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer form to save. */
    // @DataMember(Order=1)
    public form: TransferForm;

    public constructor(init?: Partial<TransferFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/save/ids", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostSaveWithIds implements IReturn<TransferFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer form to save. */
    // @DataMember(Order=1)
    public form: TransferForm;

    /** @description The ID of the Institution associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TransferFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/save/codes", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormSingleResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostSaveWithCodes implements IReturn<TransferFormSingleResponse>
{
    [immerable]? = true;

    /** @description The transfer form to save. */
    // @DataMember(Order=1)
    public form: TransferForm;

    /** @description The Code of the Institution associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the transfer form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TransferFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormSingleResponse(); }
}

// @Route("/opms/form/transfer-form/delete", "DELETE")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferFormDelete implements IReturn<TransferFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The transfer form to delete. */
    // @DataMember(Order=1)
    public form: TransferForm;

    public constructor(init?: Partial<TransferFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferFormDeleteWithId implements IReturn<TransferFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TransferFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-form/delete/ids", "DELETE")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferFormDeleteWithIds implements IReturn<TransferFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TransferFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-form/delete/codes", "DELETE")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormDeleteResponse)", StatusCode=500)
// @DataContract
export class TransferFormDeleteByCodes implements IReturn<TransferFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the transfer form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber?: string;

    /** @description The Event Definition Code of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode?: string;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the transfer form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TransferFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TransferFormDeleteResponse(); }
}

// @Route("/opms/form/transfer-form/validate", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostValidate implements IReturn<TransferFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer form to validate. */
    // @DataMember(Order=1)
    public form: TransferForm;

    public constructor(init?: Partial<TransferFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormValidationResponse(); }
}

// @Route("/opms/form/transfer-form/validate/ids", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostValidateWithIds implements IReturn<TransferFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer form to validate. */
    // @DataMember(Order=1)
    public form: TransferForm;

    /** @description The ID of the Institution associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormValidationResponse(); }
}

// @Route("/opms/form/transfer-form/validate/codes", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormValidationResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostValidateWithCodes implements IReturn<TransferFormValidationResponse>
{
    [immerable]? = true;

    /** @description The transfer form to validate. */
    // @DataMember(Order=1)
    public form: TransferForm;

    /** @description The Code of the Institution associated with the transfer form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the transfer form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber?: string;

    /** @description The Code of the Event Definition associated with the transfer form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the transfer form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TransferFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormValidationResponse(); }
}

// @Route("/opms/form/transfer-form/update-status/", "POST")
// @Api(Description="Form - Transfer Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TransferFormUpdateStatusResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TransferFormUpdateStatusResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TransferFormUpdateStatusResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TransferFormUpdateStatusResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TransferFormUpdateStatusResponse)", StatusCode=500)
// @DataContract
export class TransferFormPostUpdateStatusByIds implements IReturn<TransferFormUpdateStatusResponse>, IFormPostUpdateStatusByIds
{
    [immerable]? = true;

    /** @description The ID of the patient relating to the transfer form to update. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The ID of the event definition relating to the transfer form to update. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the transfer form to update. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    /** @description The repeat of the transfer form to update. */
    // @DataMember(Order=1)
    public formRepeat?: number;

    /** @description The new form status to set on the transfer form. */
    // @DataMember(Order=2)
    public formStatus?: FormStatusType;

    public constructor(init?: Partial<TransferFormPostUpdateStatusByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TransferFormPostUpdateStatusByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TransferFormUpdateStatusResponse(); }
}

// @Route("/opms/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download-all/{PatientId}/{FormDefinitionId}/{FormId}", "GET")
export class DownloadAllFiles implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;

    public constructor(init?: Partial<DownloadAllFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAllFiles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/query/single/id/{Id}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=500)
// @DataContract
export class QueryGetSingleById implements IReturn<QuerySingleResponse>, IQueryGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the query to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<QueryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QuerySingleResponse(); }
}

// @Route("/opms/query/collection", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollection implements IReturn<QueryCollectionResponse>, IQueryGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<QueryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/collection/form-definition/id/{FormDefinitionId}/form/id/{FormId}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollectionByForm implements IReturn<QueryCollectionResponse>, IQueryGetCollectionByForm
{
    [immerable]? = true;

    /** @description The ID of the patient associated with the query to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    /** @description The ID of the Form Definition associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId: number;

    /** @description The ID of the Form associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formId: number;

    public constructor(init?: Partial<QueryGetCollectionByForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollectionByForm'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/collection/form-definition/id/{FormDefinitionId}/form/id/{FormId}/property-path/{PropertyPath}", "GET")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryCollectionResponse)", StatusCode=500)
// @DataContract
export class QueryGetCollectionByFormProperty implements IReturn<QueryCollectionResponse>, IQueryGetCollectionByFormProperty
{
    [immerable]? = true;

    /** @description The ID of the patient associated with the query to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    /** @description The ID of the Form Definition associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId: number;

    /** @description The ID of the Form associated with the query to retrieve. */
    // @DataMember(Order=1)
    public formId: number;

    /** @description The property path associated with the query to retrieve. */
    // @DataMember(Order=1)
    public propertyPath: string;

    public constructor(init?: Partial<QueryGetCollectionByFormProperty>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryGetCollectionByFormProperty'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new QueryCollectionResponse(); }
}

// @Route("/opms/query/save", "POST")
// @Api(Description="Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QuerySingleResponse)", StatusCode=500)
// @DataContract
export class QueryPostSave implements IReturn<QuerySingleResponse>
{
    [immerable]? = true;

    /** @description The query to save. */
    // @DataMember(Order=1)
    public query: Query;

    /** @description The ID of the patient associated with the query to saev. */
    // @DataMember(Order=2)
    public patientId: number;

    public constructor(init?: Partial<QueryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuerySingleResponse(); }
}

// @Route("/opms/form/query/validate", "POST")
// @Api(Description="Query - Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryValidationResponse)", StatusCode=500)
// @DataContract
export class QueryPostValidate implements IReturn<QueryValidationResponse>
{
    [immerable]? = true;

    /** @description The query to validate. */
    // @DataMember(Order=1)
    public query: Query;

    public constructor(init?: Partial<QueryPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueryValidationResponse(); }
}

// @Route("/opms/query/delete/id/{QueryId}", "DELETE")
// @Api(Description="Query - Query")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Query.QueryDeleteResponse)", StatusCode=500)
// @DataContract
export class QueryDeleteById implements IReturn<QueryDeleteResponse>, IQueryDeleteById
{
    [immerable]? = true;

    /** @description The ID of the query to delete. */
    // @DataMember(Order=1)
    public queryId: number;

    public constructor(init?: Partial<QueryDeleteById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueryDeleteById'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new QueryDeleteResponse(); }
}

// @Route("/opms/subquery/collection/query/id/{QueryId}", "GET")
// @Api(Description="Subquery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Subquery.SubqueryCollectionResponse)", StatusCode=500)
// @DataContract
export class SubqueryGetCollectionByQueryId implements IReturn<SubqueryCollectionResponse>, ISubqueryGetCollectionByQueryId
{
    [immerable]? = true;

    /** @description The ID of the Query associated with the subquery to retrieve. */
    // @DataMember(Order=1)
    public queryId: number;

    public constructor(init?: Partial<SubqueryGetCollectionByQueryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubqueryGetCollectionByQueryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SubqueryCollectionResponse(); }
}

// @Route("/opms/subquery/save", "POST")
// @Api(Description="Subquery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Subquery.SubquerySingleResponse)", StatusCode=500)
// @DataContract
export class SubqueryPostSave implements IReturn<SubquerySingleResponse>
{
    [immerable]? = true;

    /** @description The subquery to save. */
    // @DataMember(Order=1)
    public subquery: Subquery;

    public constructor(init?: Partial<SubqueryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubqueryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SubquerySingleResponse(); }
}

// @Route("/opms/event-state/id/{Id}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesById implements IReturn<EventStateResponse>, IPatientGetEventStatesById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventStatesById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/event-state/study-number/{StudyNumber}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesByStudyNumber implements IReturn<EventStateResponse>, IPatientGetEventStatesByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber?: string;

    public constructor(init?: Partial<EventStatesByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/form-state/ids/{Id}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=500)
// @DataContract
export class FormStatesByIds implements IReturn<FormStateResponse>, IPatientGetFormStatesByIds
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description The event definition ID of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The event repeat of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    public constructor(init?: Partial<FormStatesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormStatesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormStateResponse(); }
}

export class GetUserPermissions implements IReturn<UserPermissionsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUserPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserPermissionsResponse(); }
}

export class PostHasOpmsPermissionsByIds implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public patientId?: number;
    public permissions?: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class PostHasOpmsPermissionsByCodes implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupCode?: string;
    public coordinatingGroupCode?: string;
    public institutionCode?: string;
    public patientStudyNumber?: string;
    public permissions?: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class GetInstitutionPersonnelEmailAddresses implements IReturn<InstitutionPersonnelEmailAddressesResponse>, IGet
{
    [immerable]? = true;

    public institutionCode?: string;
    public roles?: number[];
    public ids?: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelEmailAddresses>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelEmailAddresses'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelEmailAddressesResponse(); }
}

export class GetInstitutionPersonnel implements IReturn<InstitutionPersonnelResponse>, IGet
{
    [immerable]? = true;

    public institutionCode?: string;
    public roles?: number[];

    public constructor(init?: Partial<GetInstitutionPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelResponse(); }
}

export class GetInstitutionPersonnelNames implements IReturn<InstitutionPersonnelNamesResponse>, IGet
{
    [immerable]? = true;

    public institutionCode?: string;
    public roles?: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelNames>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelNames'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelNamesResponse(); }
}

export class GetTrialPersonnelHasActiveRole implements IReturn<TrialPersonnelActiveRoleResponse>, IGet
{
    [immerable]? = true;

    public personId: number;
    public institutionCode?: string;
    public roles?: number[];

    public constructor(init?: Partial<GetTrialPersonnelHasActiveRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelHasActiveRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialPersonnelActiveRoleResponse(); }
}

export class GetUserPersonnelEmailAddress implements IReturn<UserPersonnelEmailAddressResponse>, IGet
{
    [immerable]? = true;

    public userName?: string;

    public constructor(init?: Partial<GetUserPersonnelEmailAddress>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserPersonnelEmailAddress'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserPersonnelEmailAddressResponse(); }
}

// @Route("/opms/protocol/{InstCode}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetSiteProtocol implements IReturn<GetSiteProtocolResponse>, IGet
{
    [immerable]? = true;

    public instCode?: string;

    public constructor(init?: Partial<GetSiteProtocol>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteProtocol'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteProtocolResponse(); }
}

// @Route("/opms/protocol/new-protocol-check", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class CheckAnyOpmsInstitutionOnNewProtocol implements IReturn<CheckAnyOpmsInstitutionOnNewProtocolResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<CheckAnyOpmsInstitutionOnNewProtocol>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckAnyOpmsInstitutionOnNewProtocol'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CheckAnyOpmsInstitutionOnNewProtocolResponse(); }
}



// @DataContract
export class FinanceMilestoneImportChange
{
    [immerable]? = true;
    // @DataMember(Order=1)
    public studyNumber: string;

    // @DataMember(Order=2)
    public patientId?: number;

    // @DataMember(Order=3)
    public timePoint: TimePointType;

    // @DataMember(Order=4)
    public previousDate?: string;

    // @DataMember(Order=5)
    public date: string;

    // @DataMember(Order=6)
    public added: boolean;

    // @DataMember(Order=7)
    public timePointName: string;

    public constructor(init?: Partial<FinanceMilestoneImportChange>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneImportSkip
{
    [immerable]? = true;
    // @DataMember(Order=1)
    public studyNumber: string;

    // @DataMember(Order=2)
    public rows: number[] = [];

    // @DataMember(Order=3)
    public reason: string;

    public constructor(init?: Partial<FinanceMilestoneImportSkip>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneWorkbookImportResponse
{
    [immerable]? = true;
    // @DataMember(Order=1)
    public changes: FinanceMilestoneImportChange[] = [];

    // @DataMember(Order=2)
    public unchangedCount: number;

    // @DataMember(Order=3)
    public skippedPatients: FinanceMilestoneImportSkip[] = [];

    // @DataMember(Order=4)
    public warnings: string[] = [];

    // @DataMember(Order=5)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<FinanceMilestoneWorkbookImportResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FinanceMilestoneWorkbookPostImport implements IReturn<FinanceMilestoneWorkbookImportResponse>, IPost
{
    [immerable]? = true;

    public constructor(init?: Partial<FinanceMilestoneWorkbookPostImport>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FinanceMilestoneWorkbookPostImport'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FinanceMilestoneWorkbookImportResponse(); }
}

// @DataContract
export class TissueBankImportSkip
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public studyNumber: string;

    // @DataMember(Order=2)
    public reason: string;

    public constructor(init?: Partial<TissueBankImportSkip>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SyncTissueBankDataResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public createdCount: number;

    // @DataMember(Order=2)
    public updatedCount: number;

    // @DataMember(Order=3)
    public unchangedCount: number;

    // @DataMember(Order=4)
    public skippedPatients: TissueBankImportSkip[] = [];

    // @DataMember(Order=5)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<SyncTissueBankDataResponse>) { (Object as any).assign(this, init); }
}

// @ValidateRequest(Validator="IsAuthenticated")
// @DataContract
export class SyncTissueBankData implements IReturn<SyncTissueBankDataResponse>, IPost
{
    [immerable]? = true;


    public constructor(init?: Partial<SyncTissueBankData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SyncTissueBankData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SyncTissueBankDataResponse(); }
}
